<template>
  <section class="partners container py-5">
    <Title title="همکاران"></Title>
    <section class="partners-grid my-md-5 mt-5">
      <div class="order-md-0 order-1">
        <h6 class="fontsize-heavy text-right d-md-block d-none">
          همکاری با ما
        </h6>
        <p
          class="fontsize-mini text-justify text-color-444 line-height2-5 my-md-4 mb-4 weight-light"
          :class="{ moveToTop: data.site_joinus.length > 768 }"
        >
          <span>
            {{ data.site_joinus }}
          </span>
        </p>
        <div class="partners-buttons d-flex justify-content-around">
          <router-link
            to="/partner-list"
            class="get-form btn-hover-bulgy fontsize-small weight-light rounded-pill py-1 px-lg-5 px-4"
          >
            لیست همکاران</router-link
          >
          <button
            class="more-btn btn-hover-bulgy fontsize-small weight-light rounded-pill py-1 px-lg-5 px-4"
            @click="showForm = true"
          >
            همکاری با ما
          </button>
        </div>
      </div>
      <div class="partners-map order-md-1 order-0">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          viewBox="0 0 593.366 538.713"
        >
          <g id="Map" transform="translate(0.25 0.25)">
            <path
              d="M348.972,540.743l.178,2.436,1.723,4.4,3.327,3.505,4.277,3.089.653.653.891,4.455v1.663l-.178.356-.772.832-1.485.891-1.723.475L352.6,562.6l-1.129-.653-.713-.891-.772-.178-3.5-1.723-2.495-.653-.475.594.535,2.97.951,2.733.059.832-.416.713.238.772.713,1.307v1.842l-.653,1.366-8.2,4.812-1.307.178-5.168-.3-3.089.772v.059l-.535-.475-1.129-.832-3.624-1.307-.535-5.584-.535-2.376-1.01-1.129-.178-1.842,1.782-4.218-.535-1.841-1.782-1.248-2.911-1.6-2.376-2.376-1.247-1.6-5.228.713-.238-.891.3-1.188.178-1.069.119-.535-.059-1.426-1.426-5.049V539.14l.475-1.129.772-1.069,1.069-.772,2.376-1.01,3.683-3.327,2.02-2.733,2.2,1.366L324.2,532.6l1.6-.059.951.119,11.406,10.158h1.069l3.5.475,1.663-.891,1.545-1.366,1.96-.356Z"
              transform="translate(-124.895 -215.38)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['23'].doctors.length > 0"
              id="23"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(200 331)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              d="M321.5,640.531l-.3.059-.3-.3-.3-.772-.238-.653-.178-.416.356-.238.891.416.3.178-.119.594.059.594Zm81.207,63.8-1.307.772-.416.119-1.426-.059-1.545-.356-.535-.059-1.96.238-.356-.059-.594.3-.357.178-.475.95-2.376-1.01-.653-.713-.059-.713.3-.416.535-.238.653-.059h.535l.713-.059.356-.356-.238-.772-.535-.416-1.248-.475-.475-.416-.238-.416-.475-1.129-.178-.356-2.317-2.376-1.01-.832-1.129-.475-5.465-1.188-1.188-.594-3.624-3.386-1.129-.713-1.247-.535-1.485-.238-2.139.3-.475-.178-.535-.356-1.129.059-1.188.3-1.9.356-1.247-.178-2.614-.594-.356-.059-.178-.238-.059-.356-.238-.416-.951-.119-1.307-.416-.653-.713-.713-1.188-.772-.475-.238,1.01-.594.059-.594-2.079-.594-.891-.475-1.247-1.188-1.9-1.129-1.188-.178-.713.653-1.842v-.951l-.653-1.01-1.069-.95-.356-.475-1.129-1.723-1.01-1.069-.238-.357-1.842-4.634-.238-1.069-.059-4.515-.357-1.485-.713-1.307-.772-.891-1.01-.653-1.307-.3-1.247-.059-.594-.178-.238-.357-.238-.713-1.485-1.842-.238-.654-.178-.95.119-.891.653-.357.594.238.594.475.535.653.3.594.3-.3-.178-.535.059-.416.178-.238.653-.594.178-.356.119-.772L340.03,646l-.3-.535-.594.178-.238-1.069-.238-.356-.356-.3-.713.3-.119-.178-.059-.594-.119-.475-.772-.119-2.376.119-.594.119-.772.475-.891-.119-.653-.594-.3-.951-.059-.891.119-.416.238-.416.475-1.069.238-.238.475.475.119-1.426.119-.238-.3-.119-.238-.178-.356-.713.238-.832v-1.426l-.178-1.366-.238-.95-.416-.713-.594-.832-.475-.238v1.069l-.178-.416-.891-1.307-1.6-1.366-.238-.416-.238-.653-.475-.654-1.01-1.01-1.842-.713-.238-.416-.238-.653-.416-.713-.832-.891-.832-1.247-1.366-2.554-.772-1.069-.535-.475L317.1,616l-1.188-1.188-.178-.594-.059-.654-.119-.416h.535l.059-.238-.178-.238-.416-.238.356-1.188-.713-2.02.178-.891-.416-.356-.475-.653-.416-.713-.178-.594-.178-.356-.713-.416,2.02-1.01,3.148-.535,1.782.891,4.693.238,3.624,1.307,1.129.832.535.475v1.841l.832,2.554,1.545,1.545,1.842,3.8,1.782.713,6.772.475,4.218,1.366L349,622.056l1.663,3.8L352.8,629.3l1.96,2.079,2.5.891,2.673,2.495,13.782,26.02.713,3.148,4.515,12.772.772,1.247,1.366.535,1.01.594,2.317,2.733,4.158,9.327,4.04,4.99,3.98,3.743,6.119,4.455Z"
              transform="translate(-127.655 -245.664)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['7'].doctors.length > 0"
              id="7"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(221 406)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              d="M464,348.126l.356,25.069-.832,2.614-2.614,4.574-1.782,1.247-2.376.238-3.03,1.663-1.663,2.02-1.426,6.178-.95,2.733-1.188,2.2-1.723,2.079-3.208,1.9L411.01,411.868l-9.683-2.257-2.257.059-2.97,1.188-1.842,1.188-1.366,1.129-1.96,1.129-2.2.654-1.248.832-.238,1.188.891,11.168-.3,2.317-1.247,5.109-.594,4.4-.356.891.119,2.5,1.307,5.346h-.059l-10.455,3.03h-2.317l-6.832-1.545-1.426-1.247-.3-3.327-.416-1.01-.535-.059-4.218,2.257-.594.832-.891.416-4.1,2.792-2.317.3-2.97-.713-.119,1.069.713,1.723.951.951,1.188.475,1.366.238,1.782,1.366.891,2.436-.772,2.436-.594,3.683-2.614,6.475-.238,3.148.3,2.079v1.188l-.832.3-2.317.356-.653-.653-4.277-3.089-3.327-3.5-1.723-4.4-.178-2.436.3-1.248.059-2.792-2.792-9.267-.653-4.1.178-1.96,1.01-.772,1.307-.535-.059-1.129-.951-1.188-.594-1.069.119-1.129,1.247-.832.951-1.96-.535-3.743-1.6-2.911L333.6,426.9l-1.6-1.6-3.921-3.03-.3-2.851.178-2.673-.713-1.069-.238-1.069-.475-.475-.772-.238-.356-.891-.3-1.663-1.188-1.01-1.307.178-.713.772-1.247.416-4.04.119-1.188.238-3.445,2.257-1.366.3-.95-.356-1.545.356-1.96-.238-1.9-1.545-1.842-1.069-1.366.3-1.01.475-1.069.178-2.079-.238-6.059,3.267.832-2.733.654-1.01-1.307-1.723-3.089-1.188-2.673.178-1.663-.891L282.1,404.68v-.356l.178-.891.416-.713.713-.475,2.436-.832,1.426-1.01.535-4.4,1.782-2.079,4.574-1.247.713-.475.059-.653.178-.891,3.089-6.238-.059-1.6.119-1.96.713-1.485,2.554-2.139,4.871-2.911L319.169,371l1.96-1.247,1.723-1.426,1.9-.654h1.782l.832-1.426,2.911-7.129.356-2.2-.832-.475-.654-1.6.891-7.307.356-1.069,1.188-1.188,2.911-1.247,6.653-.772,2.376.119,10.337-2.673,5.941,3.208,3.03.475,8.376-.535,2.079.356,13.069,4.337,1.6.238,73.306-2.2,1.723.535.713.653Z"
              transform="translate(-115.111 -138.899)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['4'].doctors.length > 0"
              id="4"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(253 230)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              d="M411.183,519.658l7.842,2.97,4.634,4.277,3.921,4.812,7.188,18.178,5.109,9.148,4.871,6,1.366,2.376,1.069,7.782.891,2.139,4.752,3.624,6.238,3.149v.713l.832,2.792,2.5,5.168.356,1.366.713,1.188.713.772,1.366.832,7.01.653,1.842.772,6.178,15.445,1.782,5.347v1.01l-1.01.713.178,1.663,9.208,8.97.832,2.2-.356,3.921-1.544,5.7-.178,1.426.178,1.129,2.554,2.139,1.485,2.376-.178,1.96-.535.891-.713.475-.891.416-1.782-.119-2.851.772-4.158,2.257-1.188,1.9-1.01,3.089-1.782,1.663-3.861,1.188-8.139-1.188-2.852.653-1.485.653-1.485-.475-1.842-.238-8.2.713-3.208,1.129-1.307,1.663-.475,2.733-.653,1.9v.356l.356,1.01-.832,1.366L441.42,676.9l-9.386-1.663H431.2l-2.2.535-.535-.059-.535-.238-2.614-2.139-1.129-.475-6.832-.594-2.257-2.139-.832-1.6-6.119-4.455-3.98-3.743-4.04-4.99-4.158-9.327-2.317-2.733-1.01-.594-1.366-.535-.772-1.247-4.515-12.772-.713-3.149L371.5,598.965l-2.673-2.5-2.5-.891-1.96-2.079-2.139-3.446-1.663-3.8-2.079-2.317-4.218-1.366-6.772-.475-1.782-.713-1.842-3.8-1.545-1.545-.832-2.554v-1.9l3.089-.772,5.168.3,1.307-.178,8.2-4.812.653-1.366v-1.842L359.2,561.6l-.238-.772.416-.713-.059-.832-.951-2.733-.535-2.97.475-.594,2.495.653,3.5,1.723.772.178.713.891,1.129.653,3.267.891,1.723-.475,1.485-.891.772-.832.178-.356v-1.663l-.891-4.455,2.317-.356.832-.3V547.46l-.3-2.079.238-3.148,2.614-6.475.594-3.683.772-2.436-.891-2.436-1.782-1.366-1.366-.238-1.188-.475-.95-.951-.713-1.723.119-1.069,2.97.713,2.317-.3,4.1-2.792.891-.416.594-.832,4.218-2.257.535.059.416,1.01.3,3.327,1.426,1.247,6.832,1.545h2.317l10.455-3.03Z"
              transform="translate(-139.225 -209.859)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['17'].doctors.length > 0"
              id="17"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(270 380)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              d="M577.564,112.385l.238,2.733-.238,1.129.119,1.426.357,1.6-.06.95-.594,2.5.059,1.782,1.069,1.248,1.426.713,1.247.95.594,2.376-1.723,2.376-3.564,1.247-.832.119-.95.416-.951.832-2.2.951-2.257,3.98-.951.891-1.247,1.069-5.7,8.851-2.555,5.644-.594,4.218L557.247,163l-1.6.772-10.931-1.545-2.614.3-5.406,3.089-5.168,4.1-1.9,2.079-4.337,2.079-2.139.475-2.436-.416-6,.119-1.248-1.9-3.267-3.386-6.772-4.1-1.069-1.842-.356-.95v-.535l4.634.416.475.3.535.178,3.8-1.069.416-.3.178-.653v-3.98l-.119-.653-.475-.238-.594-.238.119-.594.653-1.307-.713-1.129-.475-1.426-.713-3.208-.891-2.554-.178-.535-.3-3.267,8.376.713h.653l.535-.238.594-.594.535-.356.653-.059.713.119h.713l1.069-.356,5.228-3.03.653-.119,1.9.416h.653l.475-.238.772-.772.594-.3.356-.356,1.485-.95.772-.653.178-.3.059-.594.416-.951.119-.535v-.95l-.178-.535-.356-.3-.059-.238-.059-.832.535-1.188.119-.772.178-.594.356-.653.951-1.01,4.634-3.208,1.426-1.6.238-.416.119-.535.416-.178.772-.178.178-.3.356-.713.238-.3.594-.238,1.782-.3.416-.178.238-.594.713-.416,1.366-.475h.356l.653-.535.594-.356,2.317-1.723.713-.356,1.96-.059,6.059-1.307h.951l1.9.475,1.188.653.475.178h1.545l.535.178.832.416.416.178h.475l4.4-.772,1.247.119.119.059Z"
              transform="translate(-204.379 -45.613)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['24'].doctors.length > 0"
              id="24"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(323 100)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              id="mazandaran"
              d="M430.635,191.253v.535l.356.95,1.069,1.842,6.772,4.1,3.267,3.386,1.247,1.9-3.089.95L437.7,206.4l-2.317,2.317-1.069,2.139-.713,2.257-.475,3.089-1.188,1.426-3.148,2.792-.713,1.069-.356.951-.772,1.01-1.307,1.188-2.2,1.188-2.317.713-1.545.238-1.01-.535-1.6.535-1.96,1.129-1.426.416-3.089.3-.475.238-2.733-1.9-1.366-.356-1.01.594-1.6.238-2.317-.475-3.5-1.9-2.792-.535-2.2-.891-2.02-.3-2.792,2.257L383.7,230.4l-2.139.891-2.436-.178-1.485-.535-.951-.535-1.069-1.307-1.782-3.327-3.148-3.386-4.158-1.663-4.693-.416-3.327-1.96-2.02-2.317-5.049-1.129-1.247-.535-1.188-1.129-.535-.772-1.96-.772-5.109-1.01v-.772l-.356-1.069-4.99-3.8-1.723-.891-8.139-6.95,1.545-1.01,1.9-3.386.653-3.148,1.247-1.248,1.6-.832,1.069-1.485.3-1.129L336,185.61l.594.178.475.178.891,1.01.475.356,4.812,2.673,4.455,3.148,2.555,1.129,8.554,1.723,5.465,1.6,5.7,1.01,5.465,1.6,5.7-.772,5.049-1.842,5.287-1.307,5.465-1.069,5.228-1.069,5.228-1.545,5.109-1.6,10.158-2.257,1.426-.238,12.059-.713,2.2-.535,1.485-1.247-.059,1.485-1.723.594-2.2.238-1.366.475-.416.178-.416-.059-.832-.238-.475.059-.832.3-.475.119-1.842-.238h-1.545l.238.416.416.178,1.01-.059-.832.238.713,1.01,1.247.535h.178Z"
              transform="translate(-133.014 -75.532)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['27'].doctors.length > 0"
              class="circle"
              id="27"
              data-name="Component 19 – 4"
              transform="translate(263 130)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              d="M552.839,188.286l.594-.178,1.01.059,1.247.772.713,2.97-.772,3.564-1.247,2.376-.475,4.158.594,7.188.95,4.574.891,2.139,7.248,5.941,2.02,2.317-.475,2.673-5.346,9.208-1.307,3.03-.891.713-6.535,2.436-3.445,2.079-3.98,3.683-4.931,6.119L527.652,272.7l-3.386,1.782-7.841-.178-2.851.535-.535.238v.059l-.3-.356-.713-.653-1.723-.535L437,275.79l-1.6-.238-13.069-4.337-2.079-.356-8.376.535-3.03-.475-5.94-3.208,1.01-1.485,1.366-3.208.832-3.267.059-3.03-.416-1.485.119-1.6.951-3.03,1.6-2.436.357-2.317-1.366-2.5-3.5-4.634-.238-1.6.238-1.723.535-2.257.416-3.5.535-.535.594.3.356.356.653.238,1.842.059,1.663,1.485,5.643,3.445,2.2.772,2.376.059,6.891,2.02,2.5.119,3.5-1.188,3.03-1.6,4.871-4.455,1.01-3.445-.416-3.8-.95-4.218.475-.238,3.089-.3,1.426-.416,1.96-1.129,1.6-.535,1.01.535,1.545-.238,2.317-.713,2.2-1.188,1.307-1.188.772-1.01.356-.951.713-1.069,3.148-2.792,1.188-1.426.475-3.089.713-2.257,1.069-2.139,2.317-2.317,2.554-1.485,3.089-.95,6-.119,2.436.416,2.139-.475,4.337-2.079,1.9-2.079,5.168-4.1,5.406-3.089,2.614-.3,10.931,1.545,1.6-.772,1.01-2.614.594-4.218,2.554-5.644,5.7-8.851,1.248-1.069,4.693,6.238,2.139,1.545,1.247-.238,1.485.653-.356.891-1.782.535-.772.594-.178.594.356.713.178,1.01-.178,2.614-.535,2.317-.119.772.535,1.188,3.683,4.1,3.445,3.03,1.723.535,2.97.535,1.485.594Z"
              transform="translate(-164.149 -65.911)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['15'].doctors.length > 0"
              id="15"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(320 160)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              d="M420.088,251.671l.951,4.218.416,3.8-1.01,3.446-4.871,4.455-3.03,1.6-3.5,1.188-2.5-.119-6.891-2.02-2.376-.059-2.2-.772-5.644-3.446-1.663-1.485-1.842-.059-.653-.238-.356-.356-.594-.3-.535.535-.416,3.5-.535,2.257-.238,1.723.238,1.6,3.5,4.634,1.366,2.5-.356,2.317-1.6,2.436-.951,3.03-.119,1.6-17.465-10.455-7.426-2.257L351,274.9v-.119l2.673-8.614-.059-2.614-.772-1.545-1.426-1.782.832-1.9,1.96-1.188,1.6-2.02.891-2.257,2.733-.178.356-1.842.119-2.436,1.842-2.139,2.5-.891,2.5.3,1.723-1.069v-2.139l.119-1.663,3.327,1.96,4.693.416,4.158,1.663,3.148,3.386,1.782,3.327,1.069,1.307.95.535,1.485.535,2.436.178,2.139-.891,3.98-4.812,2.792-2.257,2.02.3,2.2.891,2.792.535,3.5,1.9,2.317.475,1.6-.238,1.01-.594,1.366.356,2.733,1.9Z"
              transform="translate(-143.081 -98.346)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['8'].doctors.length > 0"
              id="8"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(223 160)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              d="M619.884,389.99l.178,2.792-.238,1.129-.832,1.366-.535,1.307.238.832.416.832.951,1.01v1.129l.951,2.02,1.247,2.02-.059,2.02-.713,2.02-.3,1.782-.475,1.663-4.1,5.525-1.129,3.148-3.149,4.931-1.6,4.1-.475.713-32.911-14.2-3.921-.653-.653,1.01-1.426,1.485-6.416,3.624-2.139,2.317-16.337,8.614-1.366,2.97-.356,11.287-.475,2.5-5.228,2.317-5.762.772-2.554-.475-3.921-.178L509.568,454.8l-2.733,3.03L505.41,460.5l-.653,2.614.059,1.782,1.723,3.267,1.841,4.752.713,3.564,1.01,1.188.951.713L510.7,489.91l.3,2.02.416,1.366.059,1.01-.95.713-3.149.356-.3.3-1.366.594-6.238-3.148-4.752-3.624-.891-2.139-1.069-7.782L491.39,477.2l-4.871-6-5.109-9.148-7.188-18.178-3.921-4.812-4.634-4.277-7.841-2.97-1.307-5.347-.119-2.5.356-.891.594-4.4,1.248-5.109.3-2.317L458,400.09l.238-1.188,1.248-.832,2.2-.653,1.96-1.129,1.366-1.129,1.842-1.188,2.97-1.188,2.257-.059,9.683,2.257,32.554-11.228,3.208-1.9,1.723-2.079,1.188-2.2.95-2.733,1.426-6.178,1.663-2.02,3.03-1.663,2.376-.238,1.782-1.247,2.614-4.574.832-2.614-.356-25.069v-.059l.535-.238,2.851-.535,7.841.178,3.386-1.782,11.049-18.594,12.535-3.327,12.238-5.762,7.723-2.02,3.386.891,8.97,6.891,1.069,2.376-.416,2.376-2.97,2.911-12.178,8.673-2.079,3.743-3.921,11.7-.238,6.238,1.9,10.693,1.485,2.257,6.059.772,7.842-1.842,1.366,1.663,1.188,2.376,2.317,15.5,1.96,4.574,2.614,1.485.772.594,1.96.891,2.614,1.663,2.495,3.861.772.594Z"
              transform="translate(-185.868 -122.012)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['31'].doctors.length > 0"
              id="31"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(370 250)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              d="M345.156,511.84l-1.069-.059-1.96.356-1.545,1.366-1.663.891-3.5-.475h-1.069l-11.406-10.158-.95-.119-1.6.059-5.406-2.139-2.2-1.366,1.129-2.139,1.663-2.079.059-1.663-.891-2.02-2.614-2.792-.594-1.069-1.485-1.366-.951-1.544-.951-2.139-.832-3.03-.416-.951-.475-.535-1.485-.475-.416-.475-.772-.594-.772-.951-.951-2.436-4.634-7.366-.475-2.2-.119-1.069,6.059-3.267,2.079.238,1.069-.178,1.01-.475,1.366-.3,1.842,1.069,1.9,1.545,1.96.238,1.545-.356.951.356,1.366-.3,3.446-2.257,1.188-.238,4.04-.119,1.247-.416.713-.772,1.307-.178,1.188,1.01.3,1.663.356.891.772.238.475.475.238,1.069.713,1.069-.178,2.673.3,2.851,3.921,3.03,1.6,1.6,3.564,2.733,1.6,2.911.535,3.742-.951,1.96-1.248.832-.119,1.129.594,1.069.95,1.188.059,1.129-1.307.535-1.01.772-.178,1.96.654,4.1,2.792,9.267-.059,2.792-.3,1.247Z"
              transform="translate(-121.079 -186.477)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['9'].doctors.length > 0"
              id="9"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(200 290)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              d="M242.8,442.514l1.485,3.683,1.663.891,2.673-.178,3.089,1.188,1.307,1.723-.653,1.01-.832,2.733.119,1.069.475,2.2,4.634,7.366.951,2.436.772.95.772.594.416.475,1.485.475.475.535.416.95.832,3.03.951,2.139.951,1.545,1.485,1.366.594,1.069,2.614,2.792.891,2.02-.059,1.663-1.663,2.079-1.129,2.139-2.02,2.733-3.683,3.327-2.376,1.01-1.069.772-.772,1.069-.475,1.129v2.139l1.426,5.049.059,1.426-.119.535-.178,1.069-.3,1.188.238.891,5.228-.713,1.247,1.6,2.376,2.376,2.911,1.6,1.782,1.247.535,1.842-1.782,4.218.178,1.842,1.01,1.129.535,2.376.535,5.584-4.693-.238-1.782-.891-3.148.535-2.02,1.01-.772-.356-1.129-.119-1.129.178-1.129.416-9.624,6.178-1.129.475-1.01-.238-.832-1.247-.059-.594-.059-1.6-.238-.594-.416-.713-.3-.178-.594-.178-.653-.059-1.01.178-.356.059-.356-.059-.475-.356-.238-.059-.653.119-1.129.475-.653.119-.772-.059-.3-.3.059-1.485-.535-.416-.119-.178v-.713l.178-.535v-.238l-.416-.238-.178.594-.3.594-.475.475-.475.059-.594-.357-.238-.475-.356-.357-.535-.059-.713-.238-2.02-1.188-.416-.356-.178-1.188-.535-.713-.832-.416-1.01-.238.356-.594.535-.119,1.248.178h.653l1.01-.356.535-.119.653.178,1.248.653.416.178.713.059.475.238.416.356.416.535.178-.475.594-1.01.891-1.188.178-.356.059-.653-.653.178-.475-.3-.3-.594-.238-1.307-.356.178-.475.535-.475.356.059-.475.178-.238-.3-.416-.238.06-.3.238-.475.119-.178-.119-.3-.535-.238-.119-.653.3-.594-.119-.535-.178h-.535l-.535.3-1.069-.178-.891.535-.238.713.832.416.951.178.772.475.238.654-.594.594H228.9l-1.663-.238-.356.119-1.663,1.6-.356.535-.178.475.356.3-.416.713.178.772.535.594.653.475.475.535.3.654.178.772.178,1.6-.059.416-.3.772-.059.416v.357l.178.653v.416l-.178.713-.416.594-.535.475-.653.178-2.079-.238-.535.238-.594-.3-2.139.059-1.307-.772-.475-.059-.119.594.178.416.416.653.059.535-.059.3-.238.356-.535.416-.713.178-2.673-.238-.95-.237-.475-.3-.416-.356-.356-.416-.238-.713-.059-.475-.594-1.723-.238-.416-.594-.713-.416-.832-.059-.238.059-.416.535-.535.238-.3.059-.416-.059-.356-.356-.654-1.188-1.129-.951-1.129-.653-1.01-.3-.3-.356-.119h-.356l-1.129.178-.772-.059-.3-.119-.3-.3-.119-.3-.238-1.6-.3-.772-.356-.713-.535-.535-.653-.3-3.267-.475-.059-1.069.119-17.227-.059-.475-.356-.178h-10.1l.178-14.851,4.693-12.772.178-.832-.059-.772-.416-.653-1.248-.891L191,476.85l-.3-.891-.178-.3-.178-.238-.594-.356-.178-.3-1.129-1.96-.119-.653-.3-.654-1.069-.535-.475-.535-.713-1.6-.475-.653.832-.3,3.208-2.139,1.129-1.782-.416-2.317V459.8l2.2-3.089,2.851-6.594,1.663-2.5,4.218-11.049,1.663-1.247,7.545-.535,2.2-.653,3.267-.238,3.148.951,1.6,1.544,1.9.535,6.772.713,7.188,4.931,4.337.416,2.2-.475Z"
              transform="translate(-75.815 -176.734)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['13'].doctors.length > 0"
              id="13"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(140 310)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              d="M173.014,352.5l.772.356,1.307.832.653.951,13.188,8.673,6.832.832,1.129.416.891-.238,1.6-1.663.832-.178,1.6.059,2.02-.238,8.376,3.624-.475.772-.238,1.188.416,1.01.119.832-1.247,2.851-.238.832-.178.891.416.772,1.545.891,2.02.772,3.446.3.891.3,2.436-1.545.594-.594,1.01-3.267,1.366-.772,1.723-.594,1.545-.832,1.663.535,1.366,1.6.832,1.426.059,1.01-.535,1.069-.3,1.069.3.891,1.01.832,2.257,1.188,1.069,1.129.95.713.713-.475.238-.951.594-1.188,1.069-.772.653.416.535.891.95.772.653.653v1.069l.178,1.069,1.96,1.069.3.3-.713,1.485-.119,1.96.059,1.6-3.089,6.238-.178.891-.059.653-.713.475L234.5,398.6l-1.782,2.079-.535,4.4-1.426,1.01-2.436.832-.713.475-.416.713-.178.891v.356l-2.2.475-4.337-.416-7.188-4.931-6.772-.713-1.9-.535-1.6-1.545-3.148-.951-3.267.238-2.2.654-7.544.535-1.663,1.247-4.218,11.049-1.663,2.495-.356-.356-.653-.891-4.931-10.455-3.624-4.752-1.01-1.129-.416-.238-.594-.178-.416-.416-.594-1.188-.713-.832-.356-.178h-.475l-.356-.119-.178-.475-.356-.416-3.743-1.842-1.307-.356-.772-.475-.594-.594v-.475l-.535-.238-1.485-1.188-.356-.3h-.416l-.178.178-.356-.059-.238-.416-1.129-.356-.594-.3-.356-.356-.416-.475-.119-.3.356-.654.059-.356-.119-.356-.3-.119-1.663-1.01-.653-.238-.832-1.01-.95-.535-.713-1.247-.475-.238v-.3l.475-1.426.059-.535.535-.238.535-.059.653-1.723,1.9-1.782,10.752-3.03.653-.891,1.663-1.129.772-.772.416-.832.119-1.188-.238-1.782-.713-1.663-.416-.594.535-.356.416-.713-.119-.3V362.3l.059-.654-.059-.416-.119-.356-.416-.416-.059-.356.178-.535,1.782-.891,2.2-.119,1.485-.772.178-2.079-.3-2.02.119-.832.535-.356.891-.3,2.139.3Z"
              transform="translate(-60.024 -143.568)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['26'].doctors.length > 0"
              id="26"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(120 230)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              d="M140.429,372.038l.416.594.713,1.663.238,1.782-.119,1.188-.416.832-.772.772L138.825,380l-.653.891-10.752,3.03-1.9,1.782-.653,1.723-.535.059-.535.238-.059.535-.475,1.426v.3l.475.238.713,1.248.95.535.832,1.01.653.238,1.663,1.01.3.119.119.356-.059.356-.356.653.119.3.416.475.356.356.594.3,1.129.356.238.416.356.059.178-.178h.416l.356.3,1.485,1.188.535.238v.475l.594.594.772.475,1.307.356,3.743,1.842.356.416.178.475.356.119h.475l.356.178.713.832.594,1.188.416.416.594.178.416.238,1.01,1.129,3.624,4.752,4.931,10.455.653.891.356.356L153.32,431.5l-2.2,3.089v1.842l.416,2.317-1.129,1.782-3.208,2.139-.832.3-.059-.059-.594-.238-.475-.059-.475-.713-.416-.238-.475-.119-.238-.178.059-.772.119-.416.356-.653v-.535l-.119-.475-.594-.475-.178-.416-.475-.356-.832-1.188-.891-.891-.356-.654.416-1.01.238-.416v-.475l-.178-.238-.832-.653-.535-.653-.356-.535-.356-.475-.653-.356-1.782-.594h-.416l-1.426.772-.535.178-1.069.119-.951-.178-.951-.535-1.01-.713-9.208-8.079-1.307-1.426-2.02-1.247-1.366-1.129-2.97-1.723-.891-.891-3.03-1.485-3.267-1.01-3.624.416-1.842-.238-.653-1.426.416-.475.475-.416.475-.475.178-.594-.119-.535-.475-.356-.594-.3-1.307-.119-.475-.356.059-.475.594-.356.713-.059.475.059.535-.119.653-.475.832-.832.416-.535.178-.475v-.3l-.356-.238-.119-.356v-.3l.178-.713v-.356l-.238-.594-.475-.475-.95-.772-1.248-1.723-1.01-1.01-.178-.535v-.594l-.119-.772-.238-.713-.356-.594-1.01-1.307-.475-.238-.356.119-.535.535-.95.119-.891-.238-.535-.416.475-.653,1.485-.891.356-.594-.238-.772-.653-.475-.535-.535.119-1.129-.653.178H92.192l-.535.238-.891.832-.535.356-.535.119-.178-.238V387.3l-.119-.3.713-.535.653-5.347,1.129-3.742.356-2.376-.416-1.366.535-.713,1.842.059,4.752-.594,4.574,1.9,2.495.178,2.5.594,2.02,1.247,2.257,1.96,7.723,2.5,3.624.3,5.228-1.366,4.812.238.594-1.248.475-2.376-.475-.951-.832-1.247v-1.188l4.931-1.129,1.01.119.535.119Z"
              transform="translate(-36.886 -151.525)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />

            <g
              id="6"
              v-if="provinces['6'].doctors.length > 0"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(74 240)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              d="M521.85,787.871l-.238.178-.416.119-.416-.357-.238-.535.475-.238.535-.178.119.3.178.713Zm-15.386-1.247-.3.238-.416-.059-.475-.238-.119-.416.356-.178.772-.238.119.3.059.594Zm-.832-12h-.178l-.713-.3-.178-.178-.119-1.129.119-.416.238-.238.238-.119.3.059.3.3.238.119.3.3.119.238-.653,1.366Zm-14.673-8.317-.356.178-2.5-.119-1.01-.475-.594-1.069.3-.475.475-.3.535-.178h.594l.535.178,1.129.119.416.178.119.238v.594l.416.3.059.416-.119.416Zm56.554-4.455-.653.356-.475-.3.06-.772.416-.772.475-.357.3-.059.238.356.059.772Zm-68.494-1.545-.416.416-.535-.119-.535-.238-.3-.416.238-.416h.594l.713.238Zm-8.495-4.634-.475.119-1.188-.119-.356.119-.535.3h-.594l-1.782-.3-.535-.238-.475-.3-.951-.832-.3-.3.119-.119.772-.178,2.614.772,2.257.178.772.3Zm92.019-1.247-1.188.416-.535-.238.119-.951.416-.594.772-.357,1.188-.119.178,1.069Zm-6.356-2.317-.713,1.544-.357.594-1.247,1.307-.238.475-.238.238-1.188.594-.238.356-.3.119-1.485,1.485-.891.535-.713-.3-.713-.713-.772-.594-2.02,1.069-.594.475-.594.3h-.653l-1.366-.178-.653.119-.654.3-1.6,1.188-1.723.772-1.069.772-.535.3-1.9.178-1.366.356-.535.416-.3.06-.594-.119h-.3l-.3.475-.356.238-.653.119-.238-.178-.119-.356-.178-.891.238-.594.059-.357-.178-.178-.3-1.069.3-.356,1.485.475.3-.119.3.059,1.6-.891,4.1-1.366.594-.059.535-.178,1.426-.891.594-.475,2.02-.832.951.059.535-.119.3-.3.3-.059-.238-.475.475-.535.119-.653-.119-1.544-.238-.594-.535-.535-.535-.356-.178-.3.772-.475,4.277,1.663,1.188-.3,3.208-2.079,4.04-.95h1.247l.594.178.772.3.653.535.3.654-1.01.535-1.9.535-.654.594Zm9.5-4.812-.475.059-.95-.356.059-.891.535-.772.535-.119.713.356.3.238.119.535-.119.416-.3.3-.416.238Zm73.128,35.584-.357.178-.535.891-.178,1.069.119.594.416.178,1.129.713,5.822,5.168.951,1.6.178,1.247.653.713.95.356.475.594.238.713.416.535.535.535,1.069,1.842.238.3.594.3-.119,1.069-.832.356.178.832-1.723.238-1.782.832-.654.178-.238-.059-.416-.356-.891.238-.654-.059-.653-.119-.475-.178-.416-.356-1.426-2.258-.772-.951-1.188-.535H638.4l-.3-.119-.416-.95-.356-.119h-2.673l-5.584-1.01-1.9.3-1.663-.059-.535-.3.178-.535-.891.059-.95.178-.416.238-.713.594-.475.119-.475-.238-.594.535-.3.059-.594-.178-1.069.772-1.129.178-1.01-.238-.951-.3-1.01-.178-.832-.356-.713-.891-.891-1.96-.951-1.188-1.188-.3-1.247.357-1.247.653-1.069.832-.653.416h-.475l.119-1.485.238-.713-.059-.238-.3-.772-.475-.416-.653-.178-.772-.059-.713.119-1.663.356-.416-.059-.594-.3-.416-.119-.3.059-.951.178-.772-.059-2.079-.653.238-.178-4.1-.3-.475-.238-.238-.535-.178-1.663-.713-1.723-.416-1.426-.238-.653-1.01-1.188h-.653l-.178-.594-.416-1.188-.119-.594-.3-.653-.059-.416.178-.713.951-1.01.356-.713-.416-1.069-2.02-2.257.178-.951-.238-.178-.178-1.545-.238-.772-.356-.653-.594-.535-.238-.594-.119-1.069.535-4.277-.119-1.6-1.96-8.02-.416-.594-1.069-.891-.356-.594.059-.535-.951-.653-.356-.3h.475l1.01-.475-.238-.238-.059-.356.3-.594-.95.416-.3.059-.3-.059-.3-.356-.3-.178-.356-.356-.653.3-.178-.119-.059-.653-.356.119-.238-.178v-.3l.475-.238.535-.594.238-.178v-.3l-.891-.119-.713-.475-.535-.713-.178-.772-.356.356-.416.119h-.832l-.416-.119-.535-.713-.3-.119-3.149-.059-.713-.238-.238.3-.713-.416-.95-.178-1.9-.119-.891-.178-1.6-.653-1.01-.119-1.841.06-1.01.3-.713.475-.653.3-1.96.119-.832.119-.238.178-.535.535-.178.535-.356.178-.832.594-2.079,1.247-.713.653v.119l-.713.594-.356.119-1.366.178-1.248.3-.356.059-1.01-.059-.356.059-.475.356-.238.059h-1.188l-.951-.238h-.3l-.594.238-1.01,1.01-.713.475-1.663,1.842.416-.178.416-.3.119.832-.178,1.069-.356.95-.416.713-1.01.891-1.188.594-1.248.238-1.426-.059-2.436-.891-1.426-.178-1.188.535-.356.653-.178.654-.3.416-.713.178-.594.119-1.366.356-.475.238-1.96,1.782-.356.238-2.97,2.376-3.327,1.96-.654.594-.3.119-.416-.059-.475-.356-.356-.059-2.673.238-1.307-.178-.535-.772-.416-1.01-.891-.891-1.366-.238-2.792.119-1.129-.535-.535-.891-.475-1.129-.535-1.01-.951-.772-.654-.119-.594.119-.594.119-2.317.178-.653-.059-2.139-.594-.832-.238-.594-.475-.238-.119h-.356l-.594.119-2.02.95-1.426.238-1.248.356h-.713l-1.366-.475-.713-.059-.713.416-.416-.119-1.6-1.426-2.317-1.366-2.97-2.257-.416-.535-.178-.653-.059-1.663-.3-.653-.475-.653-1.01-.594-10.455-3.564-.654-.059-.653-.238-.416-.416-.356-.594-.356-.475-1.842-.416-.3-.356-.238-.772-.653-.356-1.366-.416-2.495-2.257-1.069-.713-1.663-.772.475-.951.356-.178.594-.3.356.059,1.96-.238.535.059,1.545.356,1.426.059.416-.119,1.307-.772.832,1.6,2.257,2.139,6.832.594,1.129.475,2.614,2.139.535.238.535.059,2.2-.535h.832l9.386,1.663,3.208-1.723.832-1.366-.356-1.01v-.356l.653-1.9L489.83,735l1.307-1.663,3.208-1.129,8.2-.713,1.842.238,1.485.475,1.485-.653,2.851-.654,8.139,1.188,3.861-1.188,1.782-1.663,1.01-3.089,1.188-1.9,4.158-2.257,2.851-.772,1.782.119.891-.416.713-.475.535-.891.178-1.96-1.485-2.376-2.555-2.138-.178-1.129.178-1.426,1.545-5.7.356-3.921-.832-2.2-9.208-8.97-.178-1.663,1.01-.713v-1.01L524.167,681l2.614.178,5.525,1.6,2.792,2.139L536.4,686.7l1.366.95,1.366.654,1.545-.416,6.178-4.634,3.624-1.723.891-.119.891,1.307.594,13.307-.772,2.614.654,3.445,2.733,3.5,2.614,2.436,3.148,1.9,3.683.594,1.96-.357,3.624-1.782,3.327-3.208.951-1.129,1.366-1.129,1.663.059,3.208,1.6.238.535-.238,3.564,1.129,5.406.416.772.594.535.951.119,1.6.832,1.247,1.6.713,1.366,1.366,1.545L590.463,723l.178,1.723-.832.713-.535,1.069.713,1.01.772.416.832,1.723.951,2.733.95,12.891.653,2.02,9.5,5.049,2.079,1.545.891.3,1.485-1.366.713-1.069,1.247-.832,2.02.059,2.139,1.247,2.257,1.96,1.841,2.079.891,1.9-.3.653-1.9-1.188h-.653l-.059.654.772,2.257v.832l-.178.594-.535.713-.416,1.01-.713,6.713.178,1.01v1.01l-.357,1.9-.653.772.059.653,4.1-.238,2.5.416,1.663-.119,1.069-.535,1.069.238,1.188.535,1.9.3.594.416-.059.356-.3.594.059.713.356.713.059,1.069.535.95,1.248.3,1.544.059,1.307-.178.891-.95.891-.238,1.188.475h.891l.416.356,1.247,1.9Z"
              transform="translate(-182.823 -277.043)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['29'].doctors.length > 0"
              id="29"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(373 440)"
              fill="#f00"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              d="M195.751,57.22l.178.416,1.01.832.594.832.178.772.772.3,1.129.238.475.535-.238.713-6.95,8.257-.653,1.485-.238,2.079L191,75.22l-.059,2.139,2.851,7.842,5.049,8.02L200.563,95l1.96,1.545,1.01,1.307.059,1.069-.178,1.723.3,2.02.3.95-2.02-1.129-1.129.356-1.188.832-1.129-.178-.832-.475-.594.238-.416.653v.653l-.416.713-.891.178-2.317-2.436-1.247-.475-.891.238-.891-.356h-.238l-.475-.832-.416-.238H187.85l-.475.178-.238.356H186.9l.238-.772-1.426-1.188-.653-.653-1.842-1.248-.832-1.9-.238-2.792-.832-.713-2.257-1.188-.653-.119-.178.119-3.03-1.9-.891-4.218.238-3.564.713-1.426.3-1.129-.3-.653-2.079-1.9-2.436-3.327L169.2,69.458l-.178-3.089-.891-2.911-2.139-1.069-6.95,1.01-.891-.119-.416-.356-.95-.95-1.96.3-1.485.535-.356-1.188.119-2.02.653-1.426.772-1.01.95-1.842,2.495-1.782,1.248-1.426,2.139-.594,2.2.356,1.485-1.01-.594-1.96-1.6-.891-.059-1.129,1.188-1.485.3-2.673-1.782-4.455-.059-2.97-.475-.653.416-4.515-1.248-.475-1.96,1.782-2.079,1.248-1.248-.119-2.317,1.6-3.5,6.119.416.653.475.178-.416.475-1.9,1.485-1.129,1.6-1.307,1.01-4.574-1.307-2.02.594-2.139,1.129-2.079.772-1.6-.891-.832-2.139.475-2.436,1.248-1.663.832-.475.3-.594,1.129-.119,1.663.416.416-.356.178-1.129.059-1.129.059-.594.653-.059,1.366,1.188,1.366-.3,1.248-.713,1.9-.238,2.673-1.842.653-.891.178-.713.119-.772-.594-2.376-.416-.832-.95-.475-.416-.475-.059-.416-.119-.059-.238-.772.238-.119.475-.713.535-1.485,1.069-1.782.119-.416.3-.3,1.485-.95,3.03-1.188,1.307-.713,1.01-1.069,1.545-1.96,1.01-.832,1.248-.713,2.139-.713.713-.119.416-.238,1.6-1.663,4.277-2.436,1.782-1.842.594-.416.713-.178,2.317.059.416-.119.3-.3.356-.535.416.119.594.416,1.9,1.782,5.168,6.178,2.079,1.96.891,1.188.653,1.426-1.069.416-1.663,1.069-1.9.356-1.01.594-.891.832-.594,1.129-.059,1.366.416,1.069.772,1.069,1.723,1.663,1.782.772.416.416.951,2.02.178.475v.535l-.178.594-.238.475-.3.475-1.247.772-5.7,1.01-.059.238-.119.535-1.6,1.01-.3.475.119,1.6.594,1.129,2.02,1.6,4.04,2.02.356.3.238.95-.119.713.059.713,1.485,1.188.475.713.594.535h.951l1.545-.713h.713l.356.832.178,1.069.416.535.475.416.535.832.535.535.416.653,1.188,1.485.832,1.426.951.95h.178Z"
              transform="translate(-54.544 -2.745)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['3'].doctors.length > 0"
              id="3"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(116 46)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              d="M311.755,271.633l1.426,1.782.772,1.545.059,2.614-2.673,8.614-.891,1.247-1.01,2.911-.535,5.762-.356,1.426-.594.356-3.148,1.069-3.8.594-1.842,1.248-2.673.772-2.792-.416-1.723,1.426-.059,2.436.653.891-.356.772-2.851,1.6-.3,1.96,1.663,1.9,1.366,1.247,1.129.535,1.188-.119.95.535.891,1.069.475,1.069-.119,1.545.713,1.842,1.426,1.782,2.02,1.723,7.96.713,3.148,1.723,7.069,1.96-.357,2.2-2.911,7.129-.832,1.426h-1.782l-1.9.653-1.723,1.426-1.96,1.247-12.772,3.327-4.871,2.911-2.554,2.139-.3-.3-1.96-1.069-.178-1.069v-1.069l-.653-.654-.951-.772-.535-.891-.653-.416-1.069.772-.594,1.188-.238.95-.713.475-.951-.713-1.069-1.129-2.257-1.188-1.01-.832-.3-.891.3-1.069.535-1.069-.059-1.01-.832-1.426-1.366-1.6-1.663-.535-1.545.832-1.723.594-1.366.772-1.01,3.267-.594.594-2.436,1.545-.891-.3-3.446-.3-2.02-.772-1.545-.891-.416-.772.178-.891.238-.832,1.248-2.851-.119-.832-.416-1.01.238-1.188.475-.772,3.208-2.911.535-.713.119-.891-.594-2.376-.178-2.079-.475-2.02-2.2-4.277-.238-3.921-.535-2.376-1.545-.594-.416-1.069,1.069-.416,3.148.356,1.426.653.713-.178-.535-2.851.119-2.614.772-1.366.416-1.307-.356-2.2.772-1.188,5.584-.3,2.673.475.713,1.069-.653,1.426.475,1.663,1.188,1.485,1.01.891,1.366.119.713-1.485-.653-4.04-.772-1.842L271,295.454l-1.545-.772-3.327-.891-1.366-.713-.713-.653-.059-.535.535-.653.951-.119,1.723-.535,1.485-1.723-.356-1.723-1.366-2.317-.594-2.5.95-1.248.832-.059.119.713-.059.951.594.832,1.069.238,1.01-1.188.119-1.426-.713-.951-.238-1.366v-.891l5.406-.119.891-2.139,1.307-.951,5.406-1.663,1.6-.772,1.663-.535,1.426-.059,5.525-2.376,1.782-.119.95.119,1.307.3,3.089.238,3.03.832,1.782,1.6.772.475.3-.535v-.653L305.1,269.91l.416-1.01h1.723l1.188,1.426V272.4l.178,1.248.891-.119.832-1.782Z"
              transform="translate(-103.42 -109.753)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['28'].doctors.length > 0"
              id="28"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(173 200)"
              fill="#fff"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              d="M369.46,310.891l.416,1.485-.059,3.03-.832,3.267-1.366,3.208-1.01,1.485-10.337,2.673-2.376-.119-6.654.772-2.911,1.247-1.188,1.188-.356,1.069L341.9,337.5l.653,1.6.832.475-7.069-1.96-3.148-1.723-7.96-.713-2.02-1.723-1.426-1.782-.713-1.842.119-1.545-.475-1.069-.891-1.069-.951-.535-1.188.119-1.129-.535-1.366-1.247-1.663-1.9.3-1.96,2.852-1.6.356-.772-.654-.891.059-2.436,1.723-1.426,2.792.416,2.673-.772,1.842-1.247,3.8-.594,3.149-1.069.594-.356.356-1.426.535-5.762,1.01-2.911.891-1.248v.119l8.792.059,7.426,2.257,17.465,10.455Z"
              transform="translate(-127.858 -121.565)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['19'].doctors.length > 0"
              id="19"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(2007 190)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              d="M205.141,266.4l1.01,1.842,1.426.891,6.594.238,2.673,1.426,2.554.654,2.317-.832,1.129-1.545v-.653l1.426-.594,3.386.059,2.554,1.426,1.129,1.485-.891,1.426,2.079,1.6,3.921.653.891-.178,4.337,1.069.772.535v.891l.238,1.366.713.95-.119,1.426-1.01,1.188-1.069-.238-.594-.832.059-.951-.119-.713-.832.059-.95,1.247.594,2.5,1.366,2.317.356,1.723-1.485,1.723-1.723.535-.95.119-.535.654.059.535.713.653,1.366.713,3.327.891,1.545.772,1.485,1.782.772,1.842.654,4.04-.713,1.485-1.366-.119-1.01-.891-1.188-1.485-.475-1.663.653-1.426-.713-1.069-2.673-.475-5.584.3-.772,1.188.356,2.2-.416,1.307-.772,1.366-.119,2.614.535,2.851-.713.178-1.426-.653-3.148-.356-1.069.416.416,1.069,1.545.594.535,2.376.238,3.921,2.2,4.277.475,2.02.178,2.079.594,2.376-.119.891-.535.713-3.208,2.911-8.376-3.624-2.02.238-1.6-.059-.832.178-1.6,1.663-.891.238-1.129-.416-6.832-.832-13.188-8.673-.654-.951-1.307-.832-.772-.356.535-1.01,1.129-1.723,3.03-.238,3.446.713.95-.772-.059-1.723.3-2.436-.3-1.545-.594-.891-.713.178-1.366.594-2.673,2.733-.772-1.188L191.3,307.8l-.832-.416-1.01-.238-2.257-1.188-1.6-1.307-.3-1.485.475-.594.95-.356,3.089-.356,1.426-2.139,1.247-2.733,1.01-1.188.178-1.01-.059-.594.951-.475,1.9-.594,1.129-.594.3-1.069.594-.119,1.01,2.436.653.356,1.01-.891,1.069-1.723.653-2.792-.891-3.5L200.27,283.5l-1.248-.832-1.545-1.842-3.267-7.366-2.139-3.208.475-.951,1.6-1.782.713-.119,1.426,3.03.95.3,1.01-.475.891-.832,2.2-.772V267.7l-.356-.832-.951-1.129L199.5,264.2l1.129-.3,4.515,2.5Z"
              transform="translate(-75.815 -107.723)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['30'].doctors.length > 0"
              id="30"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(133 180)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              d="M217.039,170.029l4.634,2.97,3.446,3.564,1.307,2.139,1.782,6.3-2.5.891-3.327,2.2L221.138,191l.653,2.436,1.6,2.079,1.01,2.5,1.01,1.545,1.545.772.95.059.594.3.535.653.832.416.535,1.069.535,1.9.95,1.545.713,1.6.475,4.04-.713,1.01-5.584,1.545-3.089,1.782-1.9,2.079-.178,1.545.059.416-2.792-1.307-2.02-.119-2.792.772-1.723,1.247-1.069.238-1.366.059-.95.178-.594.475.059,1.129,3.921,3.564,2.257,3.327v.653l-1.129,1.545-2.317.832-2.554-.653L205.93,230.8l-6.594-.238-1.426-.891-1.01-1.842-.3-.832-.594-1.069-.535-.475-8.495-5.168-.416-1.01.535-1.366,1.188-1.307.653-2.733.059-3.921-.594-2.139-.653-.119-.059-.238.238-.535.059-.238-.238-.95.059-.3.356-.3-.3-.475-.356-.713-.3-.832-.119-.772-.178-.416-1.01-1.069-.119-.178-15.445-3.089-.891-.891-4.277-9.5L165,185.949v-1.9l.594-1.188,4.634-4.752,1.307-2.139.95-.653,2.02-1.01,1.663-1.782,1.069-.653,1.069-.475,9.683-1.129,2.911.475,1.96-.356,7.366.772,2.317-.891,1.069-.832.356-.238.891-.238,1.247.475,2.317,2.436.891-.178.416-.713v-.653l.416-.653.594-.238.832.475,1.129.178,1.188-.832,1.129-.356,2.02,1.129Z"
              transform="translate(-67.575 -69.158)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['14'].doctors.length > 0"
              id="14"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(130 120)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              d="M290.4,201.465l8.139,6.95,1.723.891,4.99,3.8.356,1.069v.772l-7.307-.772-3.446.238-.891,1.366,1.545,2.139,1.129,1.01,2.2.653,1.426,1.188-1.01,3.327-1.426,3.03-.416,1.426-1.01,1.01-6.238,3.03-1.663,1.663-.416,1.485.238,1.129.832,1.782.653,1.069-.95-.119-1.782.119-5.525,2.376-1.426.059-1.663.535-1.6.772-5.406,1.663-1.307.951-.891,2.139-5.406.119-.772-.535-4.337-1.069-.891.178-3.921-.653-2.079-1.6.891-1.426-1.129-1.485-2.554-1.426-3.386-.059-1.426.594-2.257-3.327-3.921-3.564L238,232.831l.594-.475.95-.178,1.366-.059,1.069-.238,1.723-1.248,2.792-.772,2.02.119,2.792,1.307-.059-.416.178-1.545,1.9-2.079,3.089-1.782L262,223.921l.713-1.01-.475-4.04-.713-1.6-.951-1.545-.535-1.9-.535-1.069-.832-.416-.535-.653-.594-.3-.95-.059-1.545-.772-1.01-1.545-1.01-2.5-1.6-2.079L250.772,202l1.248-2.911,3.327-2.2,2.5-.891,2.911,1.426.059.653.416,1.188,1.723,2.2,1.842,1.782,4.218,1.248,1.6-.059.95.178.653.475,2.792.535,1.545-.238,5.762-3.148.653-.238.653-.356,2.554-.535,4.218.356Z"
              transform="translate(-97.209 -80.159)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['18'].doctors.length > 0"
              id="18"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(175 137)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              d="M46.445,32.366l-3.564,3.861-.713,1.6-.891,4.218.416,2.257.832,2.079-.059,1.96-1.129,2.079-5.287,5.465L34.326,58.8l-.356,1.723.416,1.307,1.96,2.614h.238v.535l.416.535.178.3.178.713.059.416-.178.416L37.178,68.6l1.069,10.515.653.832.178.475.238,2.376-.119.178L38.6,83.4l-.119.416.238.594.416.832.178.653,2.079,2.5.772,1.782-.356,4.812.416,2.079,1.129,1.723,8.97,5.941,3.98.713,3.327.059,4.218,3.861.535,1.01,3.8,2.2,1.366,1.188,1.426.594.891-.594.475-.772.119-.356.475-1.069,1.01-1.307,1.842-1.188,1.485-.3.772.059.832-.772,1.307-.891,1.426.238.95,1.01,1.188.772,1.6.356.95.832.119.772-.356.594,1.188,3.564v2.554l1.069,1.6,3.03.416,7.247-.832,4.277,9.5-.772.238-.891.594-.119.713.238.653-.178.594-.535,1.069-1.307,1.485L97,134.9l-3.446-.3-3.208-.891-1.188-.832-.535-.535-.594-.535-.416-.594-.238-.475-.356-.3L71.1,131.93l-7.723-1.069L60.7,131.87l-.653.891L59.99,134.6,58.5,136.86l-4.99,1.6-.95,1.01-.356.653-.653.653-.416,1.9-1.723,1.9-.475,1.248-1.248,1.188-1.01.653-.713-.238H45.2l-1.069.535-.535.178-.594.416-.713.238-.653-.119-.535-.535-.238-.653.238-.772.356-.772.356-.594.119-.772-.356-.772-.95-1.248-.178-.772.059-1.782-.119-.713-.475-.475-.535-.416-.178-.475.713-.475-.535-.772-.238-.653-.059-1.6-.178-.891-.3-.951-.535-.713-.772-.059-1.723.713-.891.059-.832-.416-.356-.416-.356-1.188-.713-.95v-.535l-.416-.416-.594-.535L31,127.534l.059-.594.594-.3.059-.832.3-1.307.594-1.366.059-.713-.3-.832-.772-1.366-.475-.653-.475-.238-.416-.059-.356-.059-.3-.238-.713-.713-.416-.059-.95.059-.832-.178-.594-.416-.238-.653.356-.95,1.069-1.366.416-.653.178-.951-.178-.832-.238-.653-.178-.653.178-1.069.3-.416.059-.416-.178-.356-.713-.356-.356-.356-.178-.119h-.3l-.594.178-.3-.059L25,107.811l-.238-.832-.653-.356-.178-.238-.3-.713v-.356l.416-1.129.238-.713-.238-.653-.238-.653-.119-.772.178-.713.416-.3.416-.3.356-.475.119-1.248-.713-.772-1.782-1.129-.238-.535-.178-.535-.3-.356-1.129.119-.238-.3-.475-1.129-.475-.356-1.129-.059-.416-.238-.178-.653.416-1.188-.3-1.426.059-.951.178-.95.3-.772-.119-.653-.713-.535-.594-.713.119-1.188.238-.356,1.069-.832.356-.535-.119-.356L17.693,80.6l-.713-.653-.891-.416-.832.119-.416.178-.475.178H13.95l-.238-.475.178-.832-.059-.238-.238-.178-.416.119-.238-.059-.3-.416-.3-.951-.178-.356-.356-.238-1.069-.535-.416-.119-1.96.238L7.3,75.791l-.535-.832.119-.475.594-.772-.059-.535L7.3,72.643l.059-.475.178-.475.535-1.069.772-.832.238-.594.238-.832.3-.535.416-.3.594-.3L10.8,67l-.238-.713V65.93l.3-.238.535-.238.238-.3.178-.535.178-.772.119-.772-.119-1.9.832-.95,1.129-.891.713-1.01-.059-.594-.178-.653-.416-.535-.416-.356-.475-.178-.416.059-1.01.594-1.545-.238-.713-.416-.119-.356.119-1.01-.059-1.01v-.416l.356-1.6.059-.653-.3-2.02L9.673,47.4v-.832l-.238-.653-.475-.416-.535-.178-.356-.178.059-.238.3-.3.119-.3-.178-.713-.119-.416-.059-.535.119-.772.832-2.851L8.96,37.831l-1.6-.772-.475-.475-.416-.594L5.931,34.5v-.713L5.4,33.376l-.178-.3L5.1,32.485l-.3-.594.475-.713.475-.416.3-.475-.3-1.545.178-.653L6.525,26.9l-.238-.95L5.1,25.059l-1.366-.713L2.9,23.752V23.4l.178-.713v-.356l-.356-.772L2.6,20.841l.059-.535-.356-.772L2.129,18.7l-.119-.416-.832-.95L1,16.861l.356-.475.594-.416.475-.178H2.9l.713.059.713-.059,1.663-.416.713.059L8.842,16.5l.772.059.653-.178,1.6-.713.594-.416L13,14.426v-.713L12.881,13l.178-.891.3-.475v-.475l-.178-1.069.059-.653.178-.535,1.01-2.079.178-.535.059-.594-.119-1.307.119-.475,3.267-2.673L18.7,1l.475.356L19.95,2.6l.475.475,1.782.832.594.535,2.554,1.842.059.059.535.356.653.119h.713l-.178.3.653.475.356.891.891,3.8.416.832.594.535-.238.535.119.238.772.594.772.059.238.475,1.129.772.535.891.3.416.3.119.238.416.772,1.663.475.832.3,1.96.178.594.832-.238,3.208,1.069.535-.356.3.059.119.238L40.8,24.7l.3.119.416.119.416.238.178.416-.238.594.178.416.594.356.238.3.416,1.188.119.356.3.178.713.356.178.238-.059.416-.238.653.059.416.356.475.653.416.713.356.356.059Z"
              transform="translate(-1 -1)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['2'].doctors.length > 0"
              id="2"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(18 60)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              d="M159.925,116.952l-.356.238-1.069.832-2.317.891-7.366-.772-1.96.356-2.911-.475-9.683,1.129-1.069.475-1.069.653-1.663,1.782-2.02,1.01-.95.653-1.307,2.139-4.634,4.752-.594,1.188v1.9l.178,1.247-7.247.832-3.03-.416-1.069-1.6v-2.554l-1.188-3.564.356-.594-.119-.772-.95-.832-1.6-.356-1.188-.772-.95-1.01-1.426-.238-1.307.891-.832.772-.772-.059-1.485.3L96.48,126.16l-1.01,1.307-.475,1.069-.119.356-.475.772-.891.594-1.426-.594-1.366-1.188-3.8-2.2-.535-1.01-4.218-3.861-3.327-.059-3.98-.713-8.97-5.941-1.129-1.723-.416-2.079.356-4.812-.772-1.782-2.079-2.5-.178-.653-.416-.832-.238-.594.119-.416.594-.416.119-.178-.238-2.376-.178-.475-.653-.832L59.708,84.516l.059-1.248.178-.416-.059-.416-.178-.713-.178-.3-.416-.535v-.535h-.238l-1.96-2.614L56.5,76.437l.356-1.723L58.579,71.8l5.287-5.465,1.129-2.079.059-1.96-.832-2.079-.416-2.257.891-4.218.713-1.6,3.564-3.861.475.178.653.356.356.059.832.059,1.782.416h2.733l2.257.95,6.475,1.366,2.02.891,1.782.475,2.376-.356.535-.238,1.6-1.129.594-.3.416-.119,1.188-.059.713-.238.356-.059.416.119,3.208,1.426.535.178.535-.059.713-.238.475-.356.475-.356.416-.475.356-.594.891-1.782.356-.535.594-.475,1.782-.891.475-.475.535-1.248.356-.535.772-.475.416-.475.772-1.366.416-.475.475-.416.535-.238h.475l.832.356.475.119.356-.059,1.842-1.01.238.772.119.059.059.416.416.475.95.475.416.832.594,2.376-.119.772-.178.713-.653.891-2.673,1.842-1.9.238-1.248.713-1.366.3L108.9,49.883l-.653.059-.059.594-.059,1.129-.178,1.129-.416.356-1.663-.416-1.129.119-.3.594-.832.475-1.248,1.663-.475,2.436.832,2.139,1.6.891,2.079-.772,2.139-1.129,2.02-.594,4.574,1.307,1.307-1.01,1.129-1.6,1.9-1.485.416-.475-.475-.178-.416-.653,3.5-6.119,2.317-1.6,1.248.119,2.079-1.248,1.96-1.782,1.248.475-.416,4.515.475.653.059,2.97,1.782,4.455-.3,2.673-1.188,1.485.059,1.129,1.6.891.594,1.96-1.485,1.01-2.2-.356-2.139.594L126.955,67.7l-2.5,1.782-.95,1.842-.772,1.01-.653,1.426-.119,2.02.356,1.188,1.485-.535,1.96-.3.951.95.416.356.891.119,6.95-1.01,2.139,1.069L138,80.536l.178,3.089,1.545,3.861,2.436,3.327,2.079,1.9.3.653-.3,1.129-.713,1.426-.238,3.564.891,4.218,3.03,1.9.178-.119.653.119,2.257,1.188.832.713.238,2.792.832,1.9,1.842,1.248.653.653,1.426,1.188-.238.772h.238l.238-.356.475-.178h1.069l.416.238.475.832h.238l.891.356Z"
              transform="translate(-23.53 -16.913)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['1'].doctors.length > 0"
              id="1"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(74 68)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              id="kermanshah"
              d="M147.461,306.335l.059.594-.178,1.01-1.01,1.188-1.247,2.733L143.659,314l-3.089.356-.951.356-.475.594.3,1.485,1.6,1.307,2.257,1.188,1.01.238.832.416.416,1.545.772,1.188,2.673-2.733,1.366-.594.713-.178.594.891.3,1.545-.3,2.436.059,1.723-.95.772-3.446-.713-3.03.238-1.129,1.723-.535,1.01-2.139-.3-.891.3-.535.356-.119.832.3,2.02-.178,2.079-1.485.772-2.2.119-1.782.891-.178.535.059.356.416.416.119.356.059.416-.059.653v.416l.119.3-.416.713-.535.356-.535-.119-1.01-.119-4.931,1.129v1.188l.832,1.248.475.95-.475,2.376-.594,1.248-4.812-.238-5.228,1.366-3.624-.3-7.723-2.5-2.257-1.96L101.3,343.4l-2.5-.594-2.5-.178-4.574-1.9-4.752.594-1.842-.059-.535.713.416,1.366-.356,2.376-1.129,3.743-.653,5.346-.713.535-.119-.238-1.426-1.069-.475-.475-.416-.594-.3-.594-.238-.653-.119-.772-.238-.594-.416-.416-.475-.416-.416-.475-2.733-4.99L74.63,344l-.891.119-.832-.059-.653-.416-.653-.891.653-.3.535-.475.475-1.01.3-.951.3-.832.772-.653.475-.475,1.248-1.01.3-.416v-.416l-.416-.653-.119-.416.059-.356.416-.713.119-.3L77.125,332l.059-.951-.119-.832-.475-.713-.653-.416h-.713l-.594.475-.594-.416-.356-.772-.95-3.089.3-.475,1.6-.356.416-.475.356-.535v-1.129l-.238-1.485.119-1.069,1.188.356,1.069.594.95.238,2.139.119.653.3.178-.059.178-.653.059-.416L81.58,320l-.356-.475-.059-.594-.059-.713-.059-.713-.475-.653-.178-.713-.238-.3-.535-.356-.416-.535.238-.594.832-.95.119-.475-.119-.713.119-.475.3-.416.416-.178.832-.059.891-.594.119-.95-.059-.951.238-.713h.713l.891.475.832.3.475-.654.238-.891.238-.713.119-.713-.3-.95-.119-.535v-.475l.178-.416.3-.356.653-.119.238-.238-.059-.653.416-.713.238-.059.475.119.653.416.3.178.416-.059.891.416.475-.119.475-.416.832-.535h.3l.535.119.772-.238.416-.119.3-.178.238-.416-.594-.772.416-1.069.653-1.129.119-.951L95.362,296H94.174l-.416-.3-.119-.594.3-.475.356-.475.178-.356.832.3,5.881,4.574,7.366,10.158,1.307.891.713-.059.119.772-.238,1.129v1.485l1.069,1.129,1.842-.238,2.733.356,2.079-.3,1.188-.654.119-1.247.653-.772.95-.178.653-.772.059-1.069.356-.832,1.307-.416,1.842-1.96,1.9-.178,1.188.119.653-.356.178-2.436.3-.772,4.4-.3,1.069-.95.119-1.248-.535-1.129.3-.713.891.059,1.248,1.069,3.5,1.6,4.693,5.287,1.307.238.95-.059Z"
              transform="translate(-29.66 -119.861)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['22'].doctors.length > 0"
              id="22"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(70 203)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              id="gilan"
              d="M295.708,145.954l-.3,1.129-1.069,1.485-1.6.832-1.248,1.248-.653,3.148-1.9,3.386-1.544,1.01-4.218-.356-2.554.535-.654.356-.653.238-5.762,3.149-1.545.238-2.792-.535-.653-.475-.951-.178-1.6.059-4.218-1.247-1.842-1.782-1.723-2.2-.416-1.188-.059-.653-2.911-1.426-1.782-6.3-1.307-2.139-3.446-3.564-4.634-2.97-.3-.951-.3-2.02.178-1.723-.059-1.069-1.01-1.307-1.96-1.545L238.5,127.36l-5.049-8.02L230.6,111.5l.059-2.139,1.01-1.545.238-2.079.653-1.485,6.95-8.257.238-.713-.475-.535-1.129-.238-.772-.3-.178-.772-.594-.832-1.01-.832-.178-.416,1.426.119.713-.238.832-.356.772-.475.653-.594.653-.416,1.01.059,1.96.416.119,3.446-.356,1.129.178.832.059,2.079.594,1.426.416,4.812,1.307,4.515-.238.772-.059.891.119.832.238.594,1.129,1.782v.356l-.178.653.356,1.545.653,1.426,1.545,2.376,2.079,2.139,2.2,1.6,4.99,2.614,2.317.772,11.762,1.6,1.307-.238,1.01-.416,1.01-.178,1.069.594-.3.059-.475-.178-.238.356,2.554,1.01,3.98.891,1.426.594,1.01.891-.119,1.426.238.535.416,1.366.3.594.416.653.713,2.079.951,1.545,1.069,1.01,2.2,1.723,1.545,1.842.475.238.594.178Z"
              transform="translate(-94.205 -36.885)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['25'].doctors.length > 0"
              id="25"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(163 97)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              id="kordestan"
              d="M161.543,246.828l-4.515-2.5-1.129.3.535,1.545.951,1.129.356.832v.95l-2.2.772-.891.832-1.01.475-.95-.3-1.426-3.03-.713.119-1.6,1.782-.475.951,2.139,3.208,3.267,7.366,1.545,1.842,1.248.832,1.723,1.723.891,3.5-.653,2.792-1.069,1.723-1.01.891-.653-.356-1.01-2.436-.594.119-.3,1.069-1.129.594-1.9.594-.95.475-.95.059-1.307-.238-4.693-5.287-3.5-1.6-1.248-1.069-.891-.059-.3.713.535,1.129-.119,1.248-1.069.95-4.4.3-.3.772-.178,2.436-.653.356-1.188-.119-1.9.178-1.842,1.96-1.307.416-.356.832-.059,1.069-.653.772-.95.178-.653.772-.119,1.247-1.188.653-2.079.3-2.733-.356-1.842.238-1.069-1.129v-1.485l.238-1.129-.119-.772-.713.059-1.307-.891-7.366-10.158-5.881-4.574-.832-.3.059-.178-.238-1.069-.713-.891-1.723-1.485-1.96-3.149-.356-1.129.059-.653.416-.416.119-.3-.475-1.069-.3-.713.3-.059.95.3.059-.535-.3-1.485v-.594l.119-.653.238-.594.416-.475.594-.178,2.2.059.594-.178,1.545-.772,1.188.059.653-.119.475-.416.416-.653.95-.594.475-.416.356-.653.059-.594-.238-.475-.475-.356-.653-.059-.594.238-.475.356-.594.238-1.307.3h-.653l-.653-.238-.416-.416-.119-.3-.178-.772-1.307-.535h-.535l-.475.178-.594.356-.594.178-1.96-.059-1.01.356-.95-.178-.713.653-.594.3-.653.059-.475-.356-.356-.059-1.129.356-.594-.178-.356-.475-.772-1.96-1.426-2.02-.95-.891-.832-.119-.356-.3-1.188-1.01-1.129-.475,1.01-.653,1.248-1.188.475-1.248,1.723-1.9.416-1.9.653-.653.356-.653.95-1.01,4.99-1.6,1.485-2.257.059-1.842.653-.891,2.673-1.01,7.723,1.069,15.921-1.485.356.3.238.475.416.594.594.535.535.535,1.188.832,3.208.891,3.446.3,2.317-1.01,1.307-1.485.535-1.069.178-.594-.238-.653.119-.713.891-.594.772-.238.891.891,15.445,3.089.119.178,1.01,1.069.178.416.119.772.3.832.356.713.3.475-.356.3-.059.3.238.951-.059.238-.238.535.059.238.653.119.594,2.139-.059,3.921-.653,2.733-1.188,1.307-.535,1.366.416,1.01,8.495,5.168.535.475.594,1.069.3.832Z"
              transform="translate(-32.217 -88.157)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['20'].doctors.length > 0"
              id="20"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(83 157)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              id="khorasanJounubi"
              d="M796.9,364.507l.356,3.267.891,5.643-.059,1.426-.95,2.139-.238,1.248.713,2.673,1.96,1.9,2.495,1.01,2.376.178,2.257-.119,1.188.059,1.069.3.475.238.475.475.3.535-.3.475-.416.178-1.485.119-.535.356-.059.535.119,1.247-.178.713-.3.416-1.01.653-.891.772-2.673,3.624-3.148,4.277-.178.535.059,2.851.416,2.376,3.03,10.158,2.376,8.079,2.376,8.97-.059,2.911-.416,2.911-.178.594-.832,1.069-.238.535.119.238.475.356-.3.772.059.356.3.772.059.772-.238,2.257.059,1.723.416,3.386-.356,2.673.059.832.475,1.723.356,3.386,1.01.416,8.317,1.247.535,2.079-.416,4.337-1.961,4.752-1.485,5.228-.653,9.386.119,2.733,1.6,6.891-.059,1.129-.475.713-1.069.416-4.158.178-2.495-2.2-4.871-6.891-3.743-2.792-2.851-.772-.713-.535-1.069-1.188-1.723-.3-22.99,6.535-1.01.475-12.238-17.881-4.4-3.267L715.4,453.912l.475-.713,1.6-4.1,3.148-4.931,1.129-3.149,4.1-5.525.475-1.663.3-1.782.713-2.02.059-2.02-1.247-2.02-.951-2.02v-1.129l-.95-1.01-.416-.832-.238-.832.535-1.307.832-1.366.238-1.129-.178-2.792.772-.891,1.307-2.257,1.01-4.336,4.277-6.475,9.683-6.416,1.366-1.426,1.485-2.436.238-1.069.891-1.723-4.634-3.386-.3-1.069-.3-.891-.713-.475-.891-.832-.119-1.6.475-2.079.772-1.9.119-1.485-.356-1.6.654-2.733.3-2.495-1.188-1.9-.178-1.01.475-1.069,1.6-.594,4.931.594,3.148,1.01.832-.653.891-.951,9.089-1.366,2.852-1.663,3.208-1.188,1.663,1.426,2.97,4.931,4.04,1.426,19.129-.059Z"
              transform="translate(-291.008 -145.598)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['10'].doctors.length > 0"
              id="10"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(480 270)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              id="khorasanRazavi"
              d="M762.845,270.328l-2.376.416-19.129.059-4.039-1.426-2.97-4.931-1.663-1.426-3.208,1.188-2.851,1.663-9.089,1.366-.891.95-.832.654-3.148-1.01-4.931-.594-1.6.594-.475,1.069.178,1.01,1.188,1.9-.3,2.5-.653,2.733.356,1.6-.119,1.485-.772,1.9-.475,2.079.119,1.6.891.832.713.475.3.891.3,1.069,4.634,3.386-.891,1.723-.238,1.069-1.485,2.436-1.366,1.426-9.683,6.416-4.277,6.475-1.01,4.337-1.307,2.257-.772.891-.772-.594-2.495-3.861-2.614-1.663-1.96-.891-.772-.594-2.614-1.485-1.96-4.574-2.317-15.5-1.188-2.376-1.366-1.663-7.842,1.842L659,287.258,657.52,285l-1.9-10.693.238-6.238,3.921-11.7,2.079-3.743,12.178-8.673,2.97-2.911.416-2.376-1.069-2.376-8.97-6.891-3.386-.891-7.723,2.02-12.237,5.762L631.5,239.615l4.931-6.119,3.98-3.683,3.445-2.079,6.535-2.436.891-.713,1.307-3.03,5.346-9.208.475-2.673-2.02-2.317-7.247-5.941-.891-2.139L647.3,194.7l-.594-7.188.475-4.158,1.247-2.376.772-3.564-.713-2.97-1.248-.772-1.01-.059-.594.178.119-1.01-.238-1.366.238-1.782,1.782-2.317,7.366-6.059,4.931.238,20.317,11.346,8.495,1.307,2.317-.594,1.188-1.069,1.01-3.03-.238-1.188-1.129-.653-.356-.594.178-1.069,1.842-1.96-.119-.891-1.01-.475-.653-.951-.238-1.01-.416.178-.416,1.188-.832.119-.594-1.069-.832-.95-1.485-1.069-.178-1.307,1.247-1.545,1.842-5.465,1.129-1.545.3-1.188.059-.772.238-.653.832-1.01.653-1.248-.178-1.545-.832-1.723-2.792-2.614-.713-1.6-.357-1.307-.594-.772-13.782-.653-1.188-.832.535-1.307.356-1.485v-1.663l1.129-1.188,3.743-2.317.594-.119.238.059.238.238.3.594.178.238.475.178h.475l.535-.178h.475l1.069.3,4.812,2.317,2.02.475,1.069.059.475.119.535.238.238.3-.059.832.475.951.119.238.059.713v.535l.178.475.535.416.475.238,2.436.356.356.178.832.535.416.119,2.792-.238.535-.3.416-.594.3-.653.356-.594.475-.3.594-.059.475.238,1.544,1.366,1.366.594.654.059.713-.059.238-.178.416-.416h.356l.654.178.654-.178.416-.475.059-.594.178-.3,1.842,1.069,2.376.535,1.247.535.416.356.416.119.891.119.3.178,1.01,1.069,4.1,2.97.653.059,1.723-.772.713.178.653.594.594.772.119.535-.119.891.3.713-.3.713-.119.475.059.772.594,2.673.356.535,1.96,1.6.772.891-.238.416-.119.594.119.3.475.119.475.416.475.119,1.01-.356.416.059.535.535.238.653.119.713.238.653.416.3.3-.059.178-.238.356-.535.3-.178h.356l4.4,1.485,2.02,1.663,1.129.713,2.5.416,1.188.535.891,1.188,1.188,2.5,1.366,2.139,3.267,3.98.653,1.069.891,2.376.653,1.069,1.01.594,15.742-.3,6.772-.119,1.544.3,1.248.119.238,1.307.356.951.059.475-.059.475-.119.416-.356.653-.119.416.059.475.178.594-.653,3.03-.178,1.9.416,1.069-.238.535.535.356.356.416.178.832v.891l.119.356.416.713.475,2.376.059,1.129v.475l-.475.653-.119.356-.059.713-.119.416-.535.3-.178.178-.119.475.119.772v.356l-.416.356-.594.535-.357.475.416.178.772.119.594.356.535.475.475.594.356.535.238.653.238.653.119,1.366.119.535v.653l-.178.832.178.3v.356l-.178.891v.891l-.119.238-.416.416-.119.238.119,1.01.416.891.95,1.485.3,1.545.119.772-.178.772-.416.713-.713.891-.356.713-.3,1.188-.178.416-.594.832-.178.416-.178.772.178,1.96-.238.653-.594.356-.772.119h-.653l-.416.356-.178.832v1.188l.178.119.119.356v.416l-.475.3.119.356,1.129,1.485.059.178-.119.772.059.3.3.356-.772,1.01-.178.535-.178,1.6-.475,1.366-.178,1.129-.475.653-.059.475.178,1.426-.119,1.307L780.608,243l-.951.3-.178.653-.594,1.069-1.01.772-.535.653-.059.891.119.951-.119.891-.3.416-.357.119-.416-.059-.416.059-.416.238-.356.594-1.426,1.6-.594.356-.772.238-1.663.238-.772.416-.416.772.3.059.3.119.178.238.238.891.3.3.772.356.356.3.3.475.475.951,2.257,2.97.356.713-7.544.416.178.832-.475.475-1.426.832-1.129,1.069-.95,1.307-.832,1.723-.238,1.663.059.475Z"
              transform="translate(-256.949 -51.418)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['11'].doctors.length > 0"
              id="11"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(463 127)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              id="khorasanShomali"
              d="M671.086,115.333l-3.743,2.317-1.129,1.188V120.5l-.356,1.485-.535,1.307,1.188.832,13.782.653.594.772.357,1.307.713,1.6,2.792,2.614.832,1.723.178,1.545-.654,1.248-.832,1.01-.238.653-.059.772-.3,1.188-1.129,1.545-1.841,5.465-1.248,1.545.178,1.307,1.485,1.069.832.951.594,1.069.832-.119.416-1.188.416-.178.238,1.01.654.95,1.01.475.119.891-1.841,1.96-.178,1.069.356.594,1.129.653.238,1.188-1.01,3.03-1.188,1.069-2.317.594-8.495-1.307-20.317-11.346-4.931-.238-7.366,6.059-1.782,2.317-.238,1.782.238,1.366-.119,1.01-4.693.832-1.485-.594-2.97-.535-1.723-.535-3.445-3.03-3.683-4.1-.535-1.188.119-.772.535-2.317.178-2.614-.178-1.01-.356-.713.178-.594.772-.594,1.782-.535.356-.891-1.485-.653-1.247.238-2.139-1.545-4.693-6.238.95-.891,2.257-3.98,2.2-.95.951-.832.95-.416.832-.119,3.564-1.248,1.723-2.376-.594-2.376-1.248-.951-1.426-.713-1.069-1.248-.059-1.782.594-2.5.059-.95-.356-1.6-.119-1.426.238-1.129-.238-2.733.95.416.535.059,2.614-.416.475-.356.3-.653.119-.713-.119-.653-.832-1.01.178-.535,1.9-1.782,1.069-.713,1.129-.416,2.792-.119.535.119.832.594.416.178.475-.059,2.436-1.129,1.485-.238.3.059,1.188,1.01,1.069.594.475.119,4.634.891,1.188.535.653.059.535-.3.416-.356,1.01-.713.356-.356.654-1.069.356-.416.535-.238h.653l.654.178.356.238.059.535.178.356.713,1.188.535,1.366.356.535,1.01,1.129.356,1.129.653.95.178.713-.119.653-.594,2.02.772,1.069,4.4,1.723.535-.059.475-.119.475-.119.535.059,1.544.475h1.545l.416-.119h.475l.416.238.416.356.535.238Z"
              transform="translate(-249.723 -41.432)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['12'].doctors.length > 0"
              id="12"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(393 86)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              id="sistanVaBalochestan"
              d="M778.714,741.974l-.178-.832.832-.356.119-1.069-.594-.3-.238-.3-1.069-1.842-.535-.535-.416-.535-.238-.713-.475-.594-.951-.356-.654-.713-.178-1.247-.95-1.6-5.822-5.168-1.129-.713-.416-.178-.119-.594.178-1.069.535-.891.357-.178.594-1.485.178-1.307V717.32l.356-.891.416-.535-.059-1.129.594-.713.475-1.307-.238-1.366-1.069-1.247-.535-1.96.713-1.6,1.01-1.188v-1.188l-1.01-.891-.475-.772.832-1.485.891-2.614-1.663-3.267-2.317-2.733-.654-2.317.119-2.2-.119-1.307L764.1,683.7v-3.445l3.5-13.841.416-3.98-.238-12.059,3.564-4.634.951-3.148-1.069-1.782-2.554-1.9-1.129-1.782,1.782-.951,3.5-1.188,7.129-4.158,1.366-1.129.891-.95.059-1.307-.3-1.366-.891-1.9-.059-2.851-.416-2.376.416-2.257,2.554-3.921.951-3.5.119-3.03-1.069-7.485-1.247-3.089-1.366-.951-.713-.713.238-2.97,6.3-29.346,1.01-.475,22.99-6.535,1.723.3,1.069,1.188.713.535,2.851.772,3.743,2.792,4.871,6.891,2.495,2.2,4.158-.178,1.069-.416.475-.713.059-1.129-1.6-6.891-.119-2.733.653-9.386,1.485-5.228,1.96-4.752.416-4.337-.535-2.079,11.228,1.663,5.228.713.772.356.594.475,1.129,1.366.178.713-.178,1.545v.713l.3.713.832,1.366.238.832.059,1.01.059.356.535,1.188.356,1.129.178.713v.713l-.238.772-.594,1.188.178.416.119,2.436-.3.356v.654l.119.238-.535.535-9.921,12.059-7.6,9.03-7.247,8.733-4.158,4.812,4.1,4.871,6.772,8.079,2.5,3.03.594.475.654.3.535.356.3.891-.059.713-.356,1.248v.653l.3.713.95,1.069.416.653.059.357.119.891.178.416.3.356.594.119.3.178.3.535.178.594.238.475.535.238.3.238.059.3-.059.356-.535.535v.416l.654.356.3.3.3.356,1.307,2.97.178.654.059.594.178.535.891,1.01.832,1.9.891,1.129,3.208,2.911,1.247,1.6,1.96,1.841.95,1.129.594.3,1.841.535,1.485.832.891.3,2.079.178.95.238,2.555,1.129,4.039.832.891.416.356.416.238.475.3.416.535.3.475.178.356.178.178.356.238.653.416.713,1.96,2.139.594.356,5.049-1.01.653.416.178,1.248-.95,7.544,1.366,5.7.594,6.653.475,4.99-.178,1.426-1.6,3.624.594.772.119.357-.059.535-.119.535-.178.356-.3.238-.475.059,1.307,1.188.475.238h.238l.416-.238h.475l.713.416.951.238.832-.059,1.782-.357.832-.119,1.6-.535h1.723l1.663-.535.3.059.416.119.772.713.356.238.772.3.238.178.356.357.416.653,1.069,2.317-.535-.238h-.653l-.594.3-.356.535-.119.356-.3.475-.178.356v.356l.119,3.921.3.653.356.535.3.594-.119.594-.475.416-1.247.238-.475.238-.238.535-.238,4.99-.356,1.426-.653.653h-.3l-.772-.416-.3-.059-.891.238-1.188-.06-1.188-.178-7.307-.178-.3.119-.238.3-.357.594-.653.356-.951.238h-.3l-.654-.238-.238.119-.535.475-.594.238-5.168.535-.535.3-.238.416-.178.178-.3.059h-.653l-.594.119-.594.416-.653.3-.238.119-.178.3-.059.3.238.594-.356.594-.95.95-.178.475.119.772.3.653.06.475-.653.356-1.188-.178-1.366-.475-1.129-.178-.535.832-.119.832-.3.356-1.248.238-.653.178-.535.3-1.129.713-3.683,1.069-.772.594-.416.891-.238,1.069-.535,3.921-1.01,7.366-.178.594-.475.594-.535.119h-.594l-.654.119-.653.951.178,1.247.3,1.307-.059,1.188-.653.713-.178.356-.119.475-.713,11.168-.95,2.792-.178-.475-.059-.535-.535-.416-.3-.3-.3.178-.059.178-.059.594-.059.178.594.653-.654-.059-.475-.178h-.535l-.653.475.772.238.3.178.238.3-.178.356-.475.594-.178.654-.238.238-.475.238-1.663.535.475.3-.713.95-5.168-1.782-1.841-.356.059-.594-.475-.832-4.277-1.545-5.049-.832-4.277-1.01-2.911-.356-.475-.3.475-.416-.772-1.069L820.3,745l-.059-1.9-.059-.3-1.129-1.129-.475-.3-.535-.059-.535.059-2.139.654-.535.3-.3.475-.713.95.238,1.129.653.3h.3l.594.654h-.357l.891.475-.119.416-.356-.059-2.2-.951-.653-.356h-1.307l-.891-.713.416-.653-.475-.238-.535-.059-1.129.059-1.01.238-.3.3.119.356.653.475-.238.594h-.832l-.594-.416-.356-.119-1.069-.119-.238-.178-.356-.475-.475-.237-1.129.059-1.545.238-1.663.059-1.129.832-1.307-.416-1.247-1.248-1.426-.356-3.5.238h-1.426l-2.317-.594-1.485-1.485-1.069-.594-1.782.357-4.455.713Z"
              transform="translate(-310.777 -216.354)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['16'].doctors.length > 0"
              id="16"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(500 450)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              id="kerman"
              d="M643.3,509.851l34.99,15.861,4.4,3.267,12.238,17.881-6.3,29.346-.238,2.97.713.713,1.366.95,1.247,3.089,1.069,7.485-.119,3.03-.951,3.5-2.554,3.921-.416,2.257.416,2.376.059,2.852.891,1.9.3,1.366-.059,1.307-.891.951-1.366,1.129-7.129,4.159-3.5,1.188-1.782.95,1.129,1.782,2.554,1.9,1.069,1.782-.951,3.148-3.564,4.634.238,12.059-.416,3.98-3.5,13.841v3.446l.713,2.911.119,1.307-.119,2.2.654,2.317,2.317,2.733,1.663,3.267-.891,2.614-.832,1.485.475.772,1.01.891v1.188l-1.01,1.188-.713,1.6.535,1.96,1.069,1.247.238,1.366-.475,1.307-.594.713.059,1.129-.416.535-.356.891v2.079l-.178,1.307-.594,1.485-1.248-1.9-.416-.356h-.891l-1.188-.475-.891.238-.891.951-1.307.178-1.545-.059-1.248-.3-.535-.95-.06-1.069-.356-.713-.059-.713.3-.594.059-.356-.594-.416-1.9-.3-1.188-.535-1.069-.238-1.069.535-1.663.119-2.5-.416-4.1.238-.059-.653.653-.772.357-1.9v-1.01l-.178-1.01.713-6.713.416-1.01.535-.713.178-.594v-.832l-.772-2.258.059-.653h.654l1.9,1.188.3-.653-.891-1.9-1.841-2.079-2.258-1.96-2.139-1.247-2.02-.059-1.248.832-.713,1.069-1.485,1.366-.891-.3-2.079-1.545-9.5-5.049-.653-2.02-.951-12.891-.95-2.733-.832-1.723-.772-.416-.713-1.01.535-1.069.832-.713-.178-1.723-1.426-2.139-1.366-1.545-.713-1.366-1.247-1.6-1.6-.832-.951-.119-.594-.535-.416-.772-1.129-5.406.238-3.564-.238-.535-3.208-1.6-1.663-.059-1.366,1.129-.95,1.129-3.327,3.208-3.624,1.782-1.96.356-3.683-.594-3.148-1.9-2.614-2.435-2.733-3.5-.653-3.446.772-2.614-.594-13.307-.891-1.307-.891.119-3.624,1.723-6.178,4.634-1.544.416-1.366-.653-1.366-.951-1.307-1.782-2.792-2.139-5.525-1.6-2.614-.178-6.178-15.445-1.841-.772-7.01-.654-1.366-.832-.713-.772-.713-1.188-.357-1.366-2.495-5.168-.832-2.792v-.713l1.366-.594.3-.3,3.148-.357.951-.713-.059-1.01-.416-1.366-.3-2.02.356-11.525-.951-.713-1.01-1.188-.713-3.564-1.842-4.752-1.723-3.267-.059-1.782.653-2.614,1.426-2.673,2.733-3.03,17.228-3.089,3.921.178,2.554.475,5.762-.772L577.3,528.8l.475-2.495.356-11.287,1.366-2.97,16.337-8.614,2.139-2.317,6.416-3.624,1.426-1.485.653-1.01,3.921.654,32.911,14.2Z"
              transform="translate(-218.912 -201.537)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['21'].doctors.length > 0"
              id="21"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(400 364)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
            <path
              id="alborz"
              d="M339.825,227.372l5.109,1.01,1.96.772.535.772,1.188,1.129,1.248.535,5.049,1.129,2.02,2.317-.119,1.663v2.139l-1.723,1.069-2.495-.3-2.5.891-1.842,2.139-.119,2.436-.356,1.842-2.733.178-.891,2.257-1.6,2.02-1.96,1.188-.832,1.9-1.426.119-.832,1.782-.891.119-.178-1.248v-2.079l-1.188-1.426h-1.723l-.416,1.01L334.3,254.4v.653l-.3.535-.772-.475-1.782-1.6-3.03-.832-3.089-.238-1.307-.3-.653-1.069-.832-1.782-.238-1.129.416-1.485,1.663-1.663,6.238-3.03,1.01-1.01.416-1.426,1.426-3.03,1.01-3.327-1.426-1.188-2.2-.653-1.129-1.01-1.545-2.139.891-1.366,3.445-.238,7.307.772Z"
              transform="translate(-131.431 -92.581)"
              fill="rgba(144,176,103,0.15)"
              stroke="#30504f"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="0.5"
            />
            <g
              v-if="provinces['5'].doctors.length > 0"
              id="5"
              class="circle"
              data-name="Component 19 – 4"
              transform="translate(202 143)"
            >
              <circle
                id="Ellipse_2"
                data-name="Ellipse 2"
                cx="5.5"
                cy="5.5"
                r="5.5"
              />
            </g>
          </g>
        </svg>
        <section
          class="partners-list text-color-theme fontsize-mini bg-white py-2 border"
        >
          <div class="triangle"></div>
          <h6 class="text-right border-bottom pb-2 px-3">{{ provinceName }}</h6>
          <div>
            <a
              v-for="(doctor, index) in doctors"
              :key="index"
              class="d-flex justify-content-between px-3"
            >
              <span>{{ doctor.name }}</span>
              <span v-if="doctor.officePhone">
                <span v-for="phone in doctor.officePhone" :key="phone">{{
                  phone
                }}</span>
              </span>
            </a>
          </div>
        </section>
      </div>
    </section>
    <div class="map-table-none"></div>
    <section v-if="showForm" @click="closeModal" id="cooperationModal">
      <div id="backgroundModal"></div>

      <div id="modalContent">
        <span @click="showForm = false" id="closeModal">X</span>
        <h3>از طريق فرم زير درخواست همكاري خود را ثبت كنيد</h3>
        <form @submit.prevent="sendCooperation()" id="modalForm">
          <div>
            <label for="firstName">{{`نام :`}} <span class="error" v-if="$v.firstName.$dirty&&!$v.firstName.minLength"> بايد بين 2 تا 20 حرف باشد</span>
              <span class="error" v-if="$v.firstName.$dirty&&!$v.firstName.required"> الزامي است</span>
            </label>
            <input :class="{successInput:$v.firstName.$dirty&&!$v.firstName.$invalid,errorInput:$v.firstName.$dirty&&$v.firstName.$invalid}" name="firstName" @blur="$v.firstName.$touch" v-model="firstName" placeholder="مانند محمد" type="text" id="firstName" />
          </div>
          <div>
            <label for="lastName">نام خانوادگي :<span class="error" v-if="$v.lastName.$dirty&&!$v.lastName.minLength"> بايد بين 2 تا 20 حرف باشد</span>
              <span class="error" v-if="$v.lastName.$dirty&&!$v.lastName.required"> الزامي است</span>
           </label>
            <input :class="{successInput:$v.lastName.$dirty&&!$v.lastName.$invalid,errorInput:$v.lastName.$invalid&&$v.lastName.$dirty}" @blur="$v.lastName.$touch" name="lastName" v-model="lastName" type="text" id="lastName" placeholder="مانند احمدي" />
          </div>
          <div v-if="homeData">
            <label for="name" id="province">استان :
              <span class="error" v-if="$v.province.$dirty&&!$v.province.required"> الزامي است</span>
            </label>
            <select :class="{successInput:$v.province.$dirty&&!$v.province.$invalid,errorInput:$v.province.$invalid&&$v.province.$dirty}" @blur="$v.province.$touch" name="province" v-model="province" id="province">
              <option v-for="item in homeData.provinces" :key="item.id" :value="item.id">{{item.name}}</option>
            </select>
          </div>
          <div v-if="homeData">
            <label for="city">شهر :
              <span class="error" v-if="$v.city.$dirty&&!$v.city.required"> الزامي است</span>

            </label>
            <select :class="{successInput:$v.city.$dirty&&!$v.city.$invalid,errorInput:$v.city.$invalid&&$v.city.$dirty}" @blur="$v.city.$touch" name="city_id" v-model="city" id="city">
              <option v-for="item in cityList" :key="item.id" :value="item.id">{{item.name}}</option>
            </select>
          </div>
          <div>
            <label for="name">شماره همراه :
              <span class="error" v-if="($v.phone.$dirty&&!$v.phone.minLength)||($v.phone.$dirty&&!$v.phone.maxLength)">بايد 11 رقمي باشد </span>
              <span class="error" v-if="$v.phone.$dirty&&!$v.phone.required"> الزامي است</span>
            </label>
            <input
            :class="{successInput:$v.phone.$dirty&&!$v.phone.$invalid,errorInput:$v.phone.$invalid&&$v.phone.$dirty}" @blur="$v.phone.$touch"
            name="phone" v-model="phone"
              :type="windowSize < 768 ? 'tell' : 'number'"
              placeholder="به   مانند 09XXXXXXXXX"
            />
          </div>
          <div>
            <label for="name">شماره مطب :
              <span class="error" v-if="($v.tell.$dirty&&!$v.tell.minLength)||($v.tell.$dirty&&!$v.tell.maxLength)">بايد 11 رقمي باشد </span>
              <span class="error" v-if="$v.tell.$dirty&&!$v.tell.required"> الزامي است</span>
            </label>
            <input
            :class="{successInput:$v.tell.$dirty&&!$v.tell.$invalid,errorInput:$v.tell.$invalid&&$v.tell.$dirty}" @blur="$v.tell.$touch"

            name="office_phone"
            v-model="tell"
              placeholder="به همراه پيش شماره مانند 021XXXX"
              :type="windowSize < 768 ? 'tell' : 'number'"
            />
          </div>
          <div id="pq">
            <span>پاسخ امنيتي :</span>
            <input :class="{successInput:pq!=null&&pq==orgSum,errorInput:pq!=null&&pq!=orgSum}" @blur="checkPQ()" id="pqInput" v-model="pq" type="text" />
            <p>
              <img
                @click="changeNumbers()"
                src="../assets/images/refresh.svg"
                alt=""
              />
              <span>{{ `${number1} + ${number2}` }}</span>
            </p>
          </div>
          <input :class="{'notAllow':$v.$invalid==true,'Allow':$v.$invalid==false&&pq==orgSum}" type="submit" value="ارسال درخواست" />
        </form>
      </div>
    </section>
  </section>
</template>

<script>
  import { required, minLength,maxLength } from 'vuelidate/lib/validators'
import Title from "./Title";
export default {
  name: "Partners",
  validations: {
    firstName: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(20)
    },
    lastName: {
      required,
      minLength: minLength(3),
      maxLength: maxLength(20)
    },
    tell:{
      required,
      minLength:minLength(11),
      maxLength: maxLength(11)
    },
    phone:{
      required,
      minLength:minLength(11),
      maxLength: maxLength(11)
    },
    province:{
      required
    },
    city:{
      required
    },
    
    
  },
  components: {
    Title,
  },
  mounted() {
    console.log(this.provinces);
    this.changeNumbers();
    const circle = document.querySelectorAll("#Map path ~ .circle");
    const pList = document.querySelector(".partners-list");
    if (window.innerWidth > 768) {
      let fakeThis = this;
      circle.forEach((item) => {
        item.addEventListener("mouseover", function (event) {
          fakeThis.provinceName = fakeThis.provinces[item.id].name;
          fakeThis.doctors = fakeThis.provinces[item.id].doctors;
          pList.classList.add("d-inline-block");
          pList.style.left = "unset";
          pList.style.top = "unset";
          let y = event.clientY;
          let x = event.clientX;
          // pList.getContext("2d").moveTo(x,y)
          if (x < pList.offsetWidth + 15) {
            pList.style.left = 20 + "px";
          } else {
            pList.style.left = x - pList.offsetWidth - 20 + "px";
          }
          pList.style.top = y + 10 + "px";
          console.log(x + "=" + y);
        });
        document.querySelector("body").addEventListener("click", function () {
          document
            .querySelector(".partners-list")
            .classList.remove("d-inline-block");
          pList.style.left = "unset";
          pList.style.top = "unset";
        });
      });
    } else {
      let fakeThis = this;
      circle.forEach((item) => {
        item.addEventListener("click", function (event) {
          fakeThis.provinceName = fakeThis.provinces[item.id].label;
          fakeThis.doctors = fakeThis.provinces[item.id].doctors;
          pList.classList.add("d-inline-block");
          document.querySelector(".map-table-none").style.display = "block";
          pList.style.left = "unset";
          pList.style.top = "unset";
          let y = event.clientY;
          let x = event.clientX;
          // pList.getContext("2d").moveTo(x,y)
          if (x < pList.offsetWidth + 15) {
            pList.style.left = 20 + "px";
          } else {
            pList.style.left = x - pList.offsetWidth - 20 + "px";
          }
          pList.style.top = y + 10 + "px";
        });
        document
          .querySelector(".map-table-none")
          .addEventListener("click", function (e) {
            console.log(e);
            document
              .querySelector(".partners-list")
              .classList.remove("d-inline-block");
            document.querySelector(".map-table-none").style.display = "none";
            pList.style.left = "unset";
            pList.style.top = "unset";
          });
      });
    }
  },
  computed: {
    cityList(){
      if(this.province==null){
        return []
      }else{
        return this.$root.homeData.cities.filter((city)=>{
          return city.province_id==this.province
        })
      }
    },
    homeData(){
      return this.$root.homeData;
    },
    windowSize() {
      return window.innerWidth;
    },
  },
  data() {
    return {
      number1: 0,
      number2: 0,
      orgSum: 0,
      showForm: false,
      provinceName: null,
      doctors: [],
      firstName:"",
      lastName:"",
      province:null,
      provinceList:[{name:"گلستان",value:1}],
      city:null,
      // cityList:[{name:"گلستان",value:1}],
      phone:null,
      tell:null,
      pq:null,
    };
  },
  methods: {
    checkPQ(){
      if(this.pq==null){
        this.pq=""
      }
    },
    resetForm(){
      this.firstName="";
      this.lastName="";
      this.province=null;
      this.city=null;
      this.phone=null;
      this.tell=null;
      this.pq=null;
      this.$v.firstName.$reset();
      this.$v.lastName.$reset();
      this.$v.province.$reset();
      this.$v.city.$reset();
      this.$v.tell.$reset();
      this.$v.phone.$reset();
    },
    sendCooperation(){
     if(this.$v.$invalid) return;

     const formD=new FormData(document.getElementById("modalForm"));
     formD.append("name",this.firstName+" "+this.lastName);
     this.$axios.post("https://api.infinity-align.com/api/doctors",formD).then((res)=>{
      alert(res.data.message)
      this.resetForm();
      this.showForm=false;
     }).catch(()=>{
      alert(" اين شماره موبايل از قبل ثبت نام شده است")
     })
    },
    changeNumbers() {
      let unit1 = Math.random() * 100;
      let unit2 = Math.random() * 100;
      this.number1 = Math.ceil(Math.random() * unit1);
      this.number2 = Math.ceil(Math.random() * unit2);
      this.orgSum = this.number1 + this.number2;
    },
    closeModal(e) {
      if (e.target.id == "backgroundModal") {
        this.showForm = false;
      }
    },
  },
  props: {
    data: Object,
    provinces: Array,
  },
};
</script>

<style scoped>
.partners-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 4rem;
}
.partners-buttons button,
.partners-buttons a {
  border: 1px solid var(--color-theme);
}
.get-form {
  background-color: var(--color-theme);
  color: white;
}
.more-btn {
  background: none;
  color: var(--color-theme);
}
.get-form:hover {
  background: none;
  color: var(--color-theme);
}
#Map path ~ .circle {
  fill: var(--color-theme);
}
#Map path ~ .circle:hover {
  cursor: pointer;
  fill: var(--color-theme2) !important;
}
/*.partners-map{*/
/*  position: relative;*/
/*}*/
.partners-list {
  min-width: 250px;
  position: fixed;
  /*right: 127px;*/
  /*top: 112px;*/
  border-radius: 12px 0 12px 12px;
  display: none;
  z-index: 3;
}
.partners-list a,
.partners-list h6 {
  color: #638832;
}
.partners-list a:hover {
  color: #444;
}
.triangle {
  position: absolute;
  width: 0;
  height: 0;
  border-right: 7px solid transparent;
  border-left: 7px solid white;
  border-bottom: 7px solid transparent;
  border-top: 7px solid white;
  right: -10px;
  top: 0;
}
.map-table-none {
  display: none;
  position: fixed;
  right: 0;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 2;
}
@media screen and (max-width: 767px) {
  .partners-grid {
    grid-template-columns: 1fr;
  }
}
@media screen and (max-width: 500px) {
  .partners-list {
    min-width: 200px;
  }
}
.moveToTop {
  height: 47vh;
  overflow: hidden;
}
.moveToTop span {
  animation: moveToTop 40s 5s linear infinite;
  position: relative;
}
@keyframes moveToTop {
  from {
    bottom: 5vh;
  }
  to {
    bottom: 60vh;
  }
}
section#cooperationModal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  z-index: 10000;
  display: flex;
}
div#backgroundModal {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  background-color: #0000007a;
}
div#modalContent h3 {
  text-align: right;
  margin: 16px;
}
div#modalContent span {
  padding: 15px;
  font-size: 30px;
  cursor: pointer;
  color: #490707;
}
div#modalContent {
  background: white;
  position: relative;
  width: 80%;
  margin: auto;
  border-radius: 8px;
}
form#modalForm div input {
  width: 100%;
  padding: 4px 8px;
  border-bottom: 1px solid #8080806b;
}

form#modalForm div {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
form#modalForm {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  padding: 16px;
}
#modalForm div select {
  width: 100%;
  border-bottom: 1px solid #8080807d;
  padding: 4px 8px;
}
div#pq input {
  width: 20% !important;
  border: 1px solid black !important;
}
div#pq p img {
  width: 22px;
}
div#pq p span {
  padding: 8px;
  background: grey;
  border-radius: 4px;
  color: white !important;
}
div#pq p {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  gap: 10px;
  margin-bottom: 0;
}
div#pq {
  flex-direction: row !important;
  align-items: center !important;
  gap: 15px;
}
div#pq span {
  font-size: 16px !important;
  color: black !important;
}
form#modalForm input[type="submit"] {
  font-size: 18px;
  background: #000000e3;
  color: white;
}
@media (max-width: 768px) {
  form#modalForm {
    gap: 7px;
    grid-template-columns: 1fr;
  }
  div#modalContent h3 {
    display: none;
  }
  span#closeModal {
    position: absolute;
    left: 0;
    top: 0;
    padding: 8px;
    font-weight: bold;
  }
  div#pq span {
    font-size: 14px !important;
  }
form#modalForm input[type="submit"] {
  font-size: 14px;
  padding: 6px 0;
}
}
span.error {
    color: red !important;
    font-size: 14px !important;
}
.errorInput{
  border-bottom: 1px solid red !important;
}
.successInput{
  border-bottom: 1px solid green !important;

}
.notAllow{
  cursor: not-allowed;
  pointer-events: nont;
  opacity: 0.6;
}
.Allow{
  background: green !important;
}
#pqInput.errorInput{
  border: 1px solid red !important;
}
#pqInput.successInput{
  border: 1px solid green !important;

}
</style>
